/*!
* # SeriouslyRAD
* http://www.seriouslyrad.com/
* 
* Copyright (c) 2016 - 2024 Seriously RAD Limited - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*
*/

{
    "use strict";
    
    // #region Console

    var console = console || {};

    (() =>
    {
        if (!console.log)
            console.log = () => { };

        if (!console.error)
            console.error = console.log;

        if (!console.trace)
            console.trace = console.log;

        if (!console.warn)
            console.warn = console.log;

        console.errorAndThrow = (...args) =>
        {
            console.error.apply(console.error, args);
            throw new Error(args.length > 0 ? args[0] : "Unknown Error");
        };

    })();

    // #endregion

    // #region Comparers

    class IComparer
    {
        constructor()
        {
        }
        compare(x, y)
        {
        }
    }

    class ObjectValueComparer extends IComparer
    {
        constructor()
        {
            super();
        }
        compare(x, y)
        {
            if (x === y)
                return 0;

            var
                xIsNullOrUndefined = Object.isNullOrUndefined(x), yIsNullOrUndefined = Object.isNullOrUndefined(y);

            if (xIsNullOrUndefined && !yIsNullOrUndefined)
                return -1;

            if (!xIsNullOrUndefined && yIsNullOrUndefined)
                return 1;

            var
                properties = Object
                    .getOwnPropertyNames(x ? x : {})
                    .concat(Object.getOwnPropertyNames(y ? y : {}))
                    .distinct()
                    .orderBy(item => item);

            for (var i = 0; i < properties.length; i++)
            {
                if (Object.prototype.hasOwnProperty.call(x, properties[i]) && !Object.prototype.hasOwnProperty.call(y, properties[i]))
                    return -1;
                else if (!Object.prototype.hasOwnProperty.call(x, properties[i]) && Object.prototype.hasOwnProperty.call(y, properties[i]))
                    return 1;

                if (x[properties[i]] === y[properties[i]])
                    continue;

                var
                    xPropertyIsNullOrUndefined = x[properties[i]] === null || x[properties[i]] === undefined, yPropertyIsNullOrUndefined = y[properties[i]] === null || y[properties[i]] === undefined;

                if (xPropertyIsNullOrUndefined && !yPropertyIsNullOrUndefined)
                    return -1;

                if (!xPropertyIsNullOrUndefined && yPropertyIsNullOrUndefined)
                    return 1;

                return x[properties[i]] < y[properties[i]] ? -1 : 1;
            }

            return 0;
        }
    }
    ObjectValueComparer.default = new ObjectValueComparer();

    class DeepObjectValueComparer extends IComparer
    {
        constructor()
        {
            super();
        }
        compare(x, y)
        {
            // https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
            var leftChain, rightChain;

            function compare2Objects(x, y)
            {
                var p;

                // remember that NaN === NaN returns false
                // and isNaN(undefined) returns true
                if (isNaN(x) && isNaN(y) && typeof x === "number" && typeof y === "number")
                    return true;

                // Compare primitives and functions.     
                // Check if both arguments link to the same object.
                // Especially useful on the step where we compare prototypes
                if (x === y)
                    return true;

                // Works in case when functions are created in constructor.
                // Comparing dates is a common scenario. Another built-ins?
                // We can even handle functions passed across iframes
                if ((typeof x === "function" && typeof y === "function") ||
                    (x instanceof Date && y instanceof Date) ||
                    (x instanceof RegExp && y instanceof RegExp) ||
                    (x instanceof String && y instanceof String) ||
                    (x instanceof Number && y instanceof Number))
                {
                    return x.toString() === y.toString();
                }

                // At last checking prototypes as good as we can
                if (!(x instanceof Object && y instanceof Object))
                    return false;

                if (Object.prototype.isPrototypeOf.call(x, y) || Object.prototype.isPrototypeOf.call(y, x))
                    return false;

                if (x.constructor !== y.constructor)
                    return false;

                if (x.prototype !== y.prototype)
                    return false;

                // Check for infinitive linking loops
                if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1)
                    return false;

                // Quick checking of one object being a subset of another.
                // todo: cache the structure of arguments[0] for performance
                for (p in y)
                {
                    if (Object.prototype.hasOwnProperty.call(y, p) !== Object.prototype.hasOwnProperty.call(x, p))
                        return false;
                    else if (typeof y[p] !== typeof x[p])
                        return false;
                }

                for (p in x)
                {
                    if (Object.prototype.hasOwnProperty.call(y, p) !== Object.prototype.hasOwnProperty.call(x, p))
                        return false;
                    else if (typeof y[p] !== typeof x[p])
                        return false;

                    switch (typeof (x[p]))
                    {
                        case "object":
                        case "function":

                            leftChain.push(x);
                            rightChain.push(y);

                            if (!compare2Objects(x[p], y[p]))
                            {
                                return false;
                            }

                            leftChain.pop();
                            rightChain.pop();
                            break;

                        default:
                            if (x[p] !== y[p])
                                return false;
                            break;
                    }
                }

                return true;
            }

            leftChain = []; //Todo: this can be cached
            rightChain = [];

            return compare2Objects(x, y);
        }
    }
    DeepObjectValueComparer.default = new DeepObjectValueComparer();

    // #endregion

    // #region Extensions

    // #region Array

    Array.isArrayLike = (arr) => typeof arr.length === "number" && arr.length >= 0 && typeof arr.push === "function";

    Array.prototype.add = function (item)
    {
        this.push(item);
        return this;
    };
    Array.prototype.addRange = function (range)
    {
        if (Array.isArray(range) && range.length)
            this.push.apply(this, range);
        return this;
    };
    Array.prototype.all = function (delegate)
    {
        if (!delegate)
            return true

        if (this.every)
            return this.every(delegate);

        for (var i = 0; i < this.length; i++)
        {
            if (!delegate(this[i], i, this))
                return false;
        }

        return true;
    };
    Array.prototype.any = function (delegate)
    {
        if (!delegate)
            return this.length > 0;

        if (this.some)
            return this.some(delegate);

        for (var i = 0; i < this.length; i++)
        {
            if (delegate(this[i], i, this))
                return true;
        }

        return false;
    };
    Array.prototype.clear = function ()
    {
        this.splice(0, this.length);
        return this;
    };
    Array.prototype.contains = function (item, comparer)
    {
        if (!comparer)
            return this.indexOf(item) > -1;

        return this.indexOfWithComparer(item, comparer) > -1;
    };
    Array.prototype.count = function (delegate)
    {
        return this.where(delegate).length;
    };
    Array.prototype.distinct = function (comparer)
    {
        var
            self = this;

        return self.where((item, index) =>
        {
            return self.indexOfWithComparer(item, comparer) === index;
        });
    };
    Array.prototype.each = function (delegate)
    {
        for (var i = 0; i < this.length; i++)
        {
            if (delegate.call(this, this[i], i) === false)
                break;
        }

        return this;
    };
    Array.prototype.first = function (delegate)
    {
        var
            items = delegate ? this.where(delegate) : this;

        if (items.length === 0)
            console.error("Sequence contains no elements");

        return items[0];
    };
    Array.prototype.firstOrDefault = function (delegate)
    {
        var
            items = delegate ? this.where(delegate) : this;

        return items.length > 0 ? items[0] : null;
    };
    Array.prototype.groupBy = function (keySelector, elementSelector, resultSelector)
    {
        var
            self = this,
            keys = this.select(keySelector).distinct(ObjectValueComparer.default),
            elements =
                keys.select(key =>
                {
                    return (
                        self
                            .select(item => ({ key: keySelector(item), element: item }))
                            .where(item => Object.valueEquals(key, item.key))
                            .select(item => elementSelector(item.element))
                    );
                });

        return (
            keys
                .select((item, index) =>
                {
                    return resultSelector(item, elements[index]);
                })
        );
    };
    Array.prototype.indexOfWithComparer = function (item, comparer)
    {
        if (!comparer)
            return this.indexOf(item);

        for (var i = 0; i < this.length; i++)
        {
            if (comparer.compare(item, this[i]) === 0)
                return i;
        }

        return -1;
    };
    Array.prototype.last = function (delegate)
    {
        var
            items = delegate ? this.where(delegate) : this;

        if (items.length === 0)
            console.error("Invalid Operation");

        return items[items.length - 1];
    };
    Array.prototype.lastOrDefault = function (delegate)
    {
        var
            items = delegate ? this.where(delegate) : this;

        return items.length > 0 ? items[items.length - 1] : null;
    };
    Array.prototype.max = function ()
    {
        var
            max = null;

        for (var i = 0; i < this.length; i++)
        {
            if (this[i] !== null)
            {
                if (max === null || max < this[i])
                    max = this[i];
            }
        }

        return max;
    };
    Array.prototype.min = function ()
    {
        var
            min = null;

        for (var i = 0; i < this.length; i++)
        {
            if (this[i] !== null)
            {
                if (min === null || min > this[i])
                    min = this[i];
            }
        }

        return min;
    };
    Array.prototype.orderBy = function (delegate)
    {
        return Array.prototype.slice.call(this).sort((a, b) =>
        {
            if (delegate(a) < delegate(b))
                return -1;
            if (delegate(a) > delegate(b))
                return 1;
            return 0;
        });
    };
    Array.prototype.orderByDescending = function (delegate)
    {
        return Array.prototype.slice.call(this).sort((a, b) =>
        {
            if (delegate(a) < delegate(b))
                return 1;
            if (delegate(a) > delegate(b))
                return -1;
            return 0;
        });
    };
    Array.prototype.remove = function (delegateOrItem)
    {
        for (var i = this.length - 1; i >= 0; i--)
        {
            var
                shouldRemove =
                    typeof delegateOrItem === "function"
                        ? delegateOrItem(this[i])
                        : this[i] === delegateOrItem;

            if (shouldRemove)
                this.splice(i, 1);
        }
        return this;
    };
    Array.prototype.select = function (delegate)
    {
        var
            arr = [];

        for (var i = 0; i < this.length; i++)
            arr.push(delegate(this[i], i));

        return arr;
    };
    Array.prototype.selectMany = function (delegate)
    {
        var
            arr = [];

        for (var i = 0; i < this.length; i++)
            arr.addRange(delegate(this[i], i));

        return arr;
    };
    Array.prototype.sequenceEqualTo = function (arr)
    {
        var
            self = this;

        return (
            arr
            && arr.length === self.length
            && arr.all((item, index) =>
            {
                return item === self[index];
            })
        );
    };
    Array.prototype.single = function (delegate)
    {
        var
            items = this.where(delegate);

        if (items.length !== 1)
            console.error("Sequence contains no elements");

        return items[0];
    };
    Array.prototype.singleOrDefault = function (delegate)
    {
        var
            items = this.where(delegate);

        if (items.length > 1)
            console.error("Invalid Operation");

        return items.length === 1 ? items[0] : null;
    };
    Array.prototype.skip = function (number)
    {
        return this.slice(number);
    };
    Array.prototype.sum = function ()
    {
        return (
            this
                .reduce((a, b) => a + b, 0)
        );
    };
    Array.prototype.take = function (number)
    {
        return this.slice(0, number);
    };
    Array.prototype.where = function (delegate)
    {
        return this.filter(delegate);
    };

    // #endregion

    // #region Date

    Date.monthArray = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
    Date.dayArray = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
    if (!Date.now)
        Date.now = () => new Date().getTime();
    Date.today = () =>
    {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    };
    Date.todayUtc = () =>
    {
        var date = new Date().convertToUTC();
        date.setHours(0, 0, 0, 0);
        return date;
    };
    Date.tryFromString = (dateString, format) =>
    {
        var
            ERROR_DATE_STRING_FORMAT = "Date string does not match supplied format.",
            ERROR_INVALID_DATE_FORMAT = "Invalid date format.";

        function getNumber(minLength, maxLength, min, max)
        {
            var
                matches = /^[0-9]+/g.exec(dateString);

            if (!matches || matches.length === 0)
                throw ERROR_DATE_STRING_FORMAT;

            var
                numbers = matches[0];

            if (minLength !== undefined && numbers.length < minLength || maxLength !== undefined && numbers.length > maxLength)
                throw ERROR_DATE_STRING_FORMAT;

            dateString = dateString.substr(numbers.length);

            var
                number = parseInt(numbers);

            if (min !== undefined && number < min || max !== undefined && number > max)
                throw ERROR_DATE_STRING_FORMAT;

            return number;
        }

        function getTimezone()
        {
            var
                matches = /^(\+|-)([0-9][0-9]):([0-9][0-9])/g.exec(dateString);

            if (!matches || matches.length === 0)
                throw ERROR_DATE_STRING_FORMAT;

            dateString = dateString.substr(6);

            return {
                positive: matches[1] === "+",
                hours: parseInt(matches[2]),
                minutes: parseInt(matches[3])
            };
        }

        function getAmPm()
        {
            var
                ampm = dateString.substr(0, 2).toUpperCase();

            switch (ampm)
            {
                case "AM":
                case "PM":
                    dateString = dateString.substr(2);
                    return ampm;
            }

            throw ERROR_INVALID_DATE_FORMAT;
        }

        function getMonth(abbreviated)
        {
            for (var j = 0; j < Date.monthArray.length; j++)
            {
                if (abbreviated)
                {
                    if (Date.monthArray[j].substr(0, 3).toLowerCase() === dateString.substr(0, 3).toLowerCase())
                    {
                        dateString = dateString.substr(3);
                        return j;
                    }
                }
                else
                {
                    if (Date.monthArray[j].toLowerCase() === dateString.substr(0, Date.monthArray[j].length).toLowerCase())
                    {
                        dateString = dateString.substr(Date.monthArray[j].length);
                        return j;
                    }
                }
            }

            throw ERROR_INVALID_DATE_FORMAT;
        }

        try
        {
            var
                year,
                month,
                day,
                hours,
                hours12,
                minutes,
                seconds,
                milliseconds,
                ampm,
                date;

            for (var i = 0; i < format.length; i++)
            {
                var
                    datePart = format[i];

                while (format.length > i && format[i + 1] === datePart[0])
                {
                    i++;
                    datePart += format[i];
                }

                if (datePart[0] === "Z")
                {
                    if (dateString[0] === "Z")
                        dateString = dateString.substr(1);
                }
                else if (datePart[0] === "t")
                    ampm = getAmPm();
                else if (datePart[0] === "f")
                {
                    milliseconds = getNumber(1, datePart.length, 0);

                    while (milliseconds.toString().length > 3)
                        milliseconds = Math.round(milliseconds / 10);
                }
                else if (datePart[0] === "s")
                    seconds = getNumber(1, 2, 0, 59);
                else if (datePart[0] === "m")
                    minutes = getNumber(1, 2, 0, 59);
                else if (datePart[0] === "h")
                    hours12 = getNumber(1, 2, 0, 11);
                else if (datePart[0] === "H")
                    hours = getNumber(1, 2, 0, 23);
                else if (datePart[0] === "d")
                    day = getNumber(1, 2, 1, 31);
                else if (datePart[0] === "M")
                {
                    switch (datePart.length)
                    {
                        case 1:
                        case 2:
                            month = getNumber(1, 2, 1, 12) - 1;
                            break;
                        case 3:
                            month = getMonth(true);
                            break;
                        case 4:
                            month = getMonth(false);
                            break;
                    }
                }
                else if (datePart[0] === "y")
                {
                    switch (datePart.length)
                    {
                        case 1:
                            year = getNumber(2, 4, 0);
                            break;
                        case 2:
                        case 3:
                        case 4:
                            year = getNumber(datePart.length, datePart.length, 0);
                            break;
                        default:
                            throw ERROR_INVALID_DATE_FORMAT;
                    }

                    var
                        currentDate = new Date(),
                        currentCentury = Math.round(currentDate.getFullYear() / 100);

                    if (year.toString().length === 2)
                    {
                        year += currentCentury * 100;
                        if (year > currentDate.getFullYear() + 20)
                            year -= 100;
                    }
                }
                else
                {
                    while (dateString.length && datePart.length && dateString[0] === datePart[0])
                    {
                        dateString = dateString.substr(1);
                        datePart = datePart.substr(1);
                    }

                    if (datePart.length)
                        throw ERROR_DATE_STRING_FORMAT;
                }
            }

            if (hours === undefined)
            {
                if (hours12 !== undefined)
                    hours = hours12 + (ampm === "PM" ? 12 : 0);
            }

            if (year === undefined)
                year = 0;

            if (month === undefined)
                month = 0;

            if (day === undefined)
                day = 1;

            if (hours === undefined)
                hours = 0;

            if (minutes === undefined)
                minutes = 0;

            if (seconds === undefined)
                seconds = 0;

            if (milliseconds === undefined)
                milliseconds = 0;

            date = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));

            return {
                success: true,
                date: date
            };
        }
        catch (e)
        {
            return { success: false, error: e };
        }
    };
    Date.fromString = (dateString, format) =>
    {
        var
            result = Date.tryFromString(dateString, format);

        if (!result.success && format.contains("f"))
            result = Date.tryFromString(dateString, format.replace(/[.f]/gi, String.empty));

        if (result.success)
            return result.date;

        console.error(result.error);
    };
    Date.prototype.addDays = function (days)
    {
        var
            date = new Date(this.valueOf());

        date.setDate(date.getDate() + days);

        return date;
    };
    Date.prototype.addHours = function (hours)
    {
        var
            hoursInMilliseconds = hours * 60 * 60 * 1000,
            date = new Date(this.valueOf());

        date.setTime(date.getTime() + hoursInMilliseconds);

        return date;
    };
    Date.prototype.addMinutes = function (minutes)
    {
        var
            minutesInMilliseconds = minutes * 60 * 1000,
            date = new Date(this.valueOf());

        date.setTime(date.getTime() + minutesInMilliseconds);

        return date;
    };
    Date.prototype.addMonths = function (months)
    {
        var
            date = new Date(this.valueOf());

        date.setMonth(date.getMonth() + months);

        return date;
    };
    Date.prototype.addSeconds = function (seconds)
    {
        var
            secondsInMilliseconds = seconds * 1000,
            date = new Date(this.valueOf());

        date.setTime(date.getTime() + secondsInMilliseconds);

        return date;
    };
    Date.prototype.addYears = function (years)
    {
        var
            date = new Date(this.valueOf());

        date.setFullYear(date.getFullYear() + years);

        return date;
    };
    Date.prototype.convertToUTC = function ()
    {
        return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
    };
    Date.prototype.createAsUTC = function ()
    {
        return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds()));
    };
    Date.prototype.toString = function (format)
    {
        if (isNaN(this.getFullYear()))
            return "Invalid Date";

        var
            dateObject = format && format.endsWith("Z") ? new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000) : this,
            year = String(dateObject.getFullYear()),
            yearShort = year.substring(2),
            month = String(dateObject.getMonth() + 1),
            day = String(dateObject.getDay()),
            date = String(dateObject.getDate()),
            hours = String(dateObject.getHours()),
            hours12 = parseInt(hours) > 12 ? String(parseInt(hours) % 12) : hours,
            ampm = hours < 12 ? "AM" : "PM",
            minutes = String(dateObject.getMinutes()),
            seconds = String(dateObject.getSeconds()),
            milliseconds = String(dateObject.getMilliseconds()),
            timezoneOffset = -dateObject.getTimezoneOffset(),
            timezone = {
                direction: timezoneOffset >= 0 ? "+" : "-",
                hours: timezoneOffset / 60,
                minutes: timezoneOffset % 60
            },
            returnString = "";

        if (typeof format === "undefined")
            format = "dd/MM/yyyy HH:mm:ss";

        returnString = String(format);

        returnString = returnString.replace(/fffffff/g, "$01");
        returnString = returnString.replace(/ffffff/g, "$01");
        returnString = returnString.replace(/fffff/g, "$01");
        returnString = returnString.replace(/ffff/g, "$01");
        returnString = returnString.replace(/fff/g, "$01");
        returnString = returnString.replace(/ff/g, "$02");
        returnString = returnString.replace(/f/g, "$03");
        returnString = returnString.replace(/ss/g, "$04");
        returnString = returnString.replace(/s/g, "$05");
        returnString = returnString.replace(/mm/g, "$06");
        returnString = returnString.replace(/m/g, "$07");
        returnString = returnString.replace(/hh/g, "$08");
        returnString = returnString.replace(/h/g, "$09");
        returnString = returnString.replace(/HH/g, "$10");
        returnString = returnString.replace(/H/g, "$11");
        returnString = returnString.replace(/dddd/g, "$12");
        returnString = returnString.replace(/ddd/g, "$13");
        returnString = returnString.replace(/dd/g, "$14");
        returnString = returnString.replace(/d/g, "$15");
        returnString = returnString.replace(/MMMM/g, "$16");
        returnString = returnString.replace(/MMM/g, "$17");
        returnString = returnString.replace(/MM/g, "$18");
        returnString = returnString.replace(/M/g, "$19");
        returnString = returnString.replace(/yyyy/g, "$20");
        returnString = returnString.replace(/yyy/g, "$21");
        returnString = returnString.replace(/yy/g, "$22");
        returnString = returnString.replace(/y/g, "$23");
        returnString = returnString.replace(/tt/g, "$24");
        returnString = returnString.replace(/Z/g, "$25");

        returnString = returnString.replace(/\$01/g, Math.floor(parseInt(milliseconds)));
        returnString = returnString.replace(/\$02/g, Math.floor(parseInt(milliseconds) / 10));
        returnString = returnString.replace(/\$03/g, Math.floor(parseInt(milliseconds) / 100));

        returnString = returnString.replace(/\$04/g, seconds.padLeft(2, "0"));
        returnString = returnString.replace(/\$05/g, seconds);

        returnString = returnString.replace(/\$06/g, minutes.padLeft(2, "0"));
        returnString = returnString.replace(/\$07/g, minutes);

        returnString = returnString.replace(/\$08/g, hours12.padLeft(2, "0"));
        returnString = returnString.replace(/\$09/g, hours12);

        returnString = returnString.replace(/\$10/g, hours.padLeft(2, "0"));
        returnString = returnString.replace(/\$11/g, hours);

        returnString = returnString.replace(/\$12/g, Date.dayArray[parseInt(day)]);
        returnString = returnString.replace(/\$13/g, Date.dayArray[parseInt(day)].substr(0, 3));
        returnString = returnString.replace(/\$14/g, date.padLeft(2, "0"));
        returnString = returnString.replace(/\$15/g, date);

        returnString = returnString.replace(/\$16/g, Date.monthArray[parseInt(month) - 1]);
        returnString = returnString.replace(/\$17/g, Date.monthArray[parseInt(month) - 1].substr(0, 3));
        returnString = returnString.replace(/\$18/g, month.padLeft(2, "0"));
        returnString = returnString.replace(/\$19/g, month);

        returnString = returnString.replace(/\$20/g, year.padLeft(4, "0"));
        returnString = returnString.replace(/\$21/g, year);
        returnString = returnString.replace(/\$22/g, yearShort);
        returnString = returnString.replace(/\$23/g, yearShort.padLeft(2, "0"));

        returnString = returnString.replace(/\$24/g, ampm);
        returnString = returnString.replace(/\$25/g, timezone.direction + timezone.hours.toString().padLeft(2, "0") + ":" + timezone.minutes.toString().padLeft(2, "0"));

        return returnString;
    };

    // #endregion

    // #region Element

    if (!Element.prototype.scrollIntoViewIfNeededSmooth)
    {
        Element.prototype.scrollIntoViewIfNeededSmooth = function (centerIfNeeded)
        {
            centerIfNeeded = centerIfNeeded === undefined ? true : !!centerIfNeeded;

            function getScrollParent(element)
            {
                if (!element)
                    return null;

                if (element.scrollHeight > element.clientHeight)
                    return element;
                else
                    return getScrollParent(element.parentNode);
            }

            var
                parent = getScrollParent(this);

            if (!parent)
                return;

            var
                elementBoundingClientRect = this.getBoundingClientRect(),
                parentBoundingClientRect = parent.getBoundingClientRect(),
                overTop = elementBoundingClientRect.top < parentBoundingClientRect.top,
                overBottom = elementBoundingClientRect.bottom > parentBoundingClientRect.bottom,
                overLeft = elementBoundingClientRect.left < parentBoundingClientRect.left,
                overRight = elementBoundingClientRect.right > parentBoundingClientRect.right,
                alignWithTop = overTop && !overBottom;

            if (overTop || overBottom || overLeft || overRight)
            {
                if (centerIfNeeded)
                {
                    var
                        animationParameters = {};

                    if (overTop || overBottom)
                        animationParameters.scrollTop = parent.scrollTop + elementBoundingClientRect.top - parentBoundingClientRect.top - parentBoundingClientRect.height / 2 + elementBoundingClientRect.height / 2;

                    if (overLeft || overRight)
                        animationParameters.scrollLeft = parent.scrollLeft + elementBoundingClientRect.left - parentBoundingClientRect.left - parentBoundingClientRect.width / 2 + elementBoundingClientRect.width / 2;

                    $$(parent).animate(animationParameters, 250);
                }
                else
                {
                    try
                    {
                        document.activeElement.scrollIntoView({
                            behavior: "smooth",
                            block: alignWithTop ? "start" : "end",
                            inline: "nearest"
                        });
                    }
                    catch (e)
                    {
                        // Fallback to prevent browser crashing
                        document.activeElement.scrollIntoView(alignWithTop);
                    }
                }
            }
        };
    }

    // #endregion

    // #region Math

    if (!Math.clamp)
        Math.clamp = (x, lower, upper) => x <= lower ? lower : x >= upper ? upper : x;

    // #endregion

    // #region Number

    Number.isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);
    Number.toStringAbbreviated = (number, dp) =>
    {
        const
            decimalPlaces = Math.pow(10, dp ?? 2),
            suffixes = [String.empty, "K", "M", "B", "T"];

        for (let i = suffixes.length - 1; i >= 0; i--)
        {
            const
                size = Math.pow(10, i * 3);

            if (size <= Math.abs(Math.round(number)))
            {
                number = Math.round(number * decimalPlaces / size) / decimalPlaces;

                if (number === 1000 && i < suffixes.length - 1)
                {
                    number = 1;
                    i++;
                }

                number += suffixes[i];
                break;
            }
        }

        return number.toString();
    };
    Number.prototype.toStringFormat = function (format)
    {
        if (format)
        {
            return (
                format.replace(/{([^:]+)(?::([0-9]*))?}/gi, (_, p1, p2) =>
                {
                    switch (p1.toLowerCase())
                    {
                        case "n":
                            return this.toLocaleString(undefined, { minimumFractionDigits: p2, maximumFractionDigits: p2 });
                        default:
                            return this.toString();
                    }
                })
            );
        }

        return this.toString();
    };

    // #endregion

    // #region Object

    Object.combine = (...args) =>
    {
        // TODO: Copy isn't deep. Child object references are copied, not cloned :S
        var
            returnValue = {};

        for (var i = 0; i < args.length; i++)
        {
            for (var property in args[i])
            {
                if (Object.prototype.hasOwnProperty.call(args[i], property))
                    returnValue[property] = args[i][property];
            }
        }

        return returnValue;
    };
    Object.compare = (o, value) =>
    {
        if (o === undefined)
            o = null;

        if (value === undefined)
            value = null;

        if (o === null || value === null)
        {
            if (o === null)
            {
                if (value !== null)
                    return -1;
                else
                    return 0;
            }
            else
                return 1;
        }

        if (typeof o !== typeof value)
            return -1;

        if (o < value)
            return -1;

        if (o > value)
            return 1;

        return 0;
    };
    Object.extend = (...args) => // [deep], target, source1, source2, .., sourceN
    {
        let
            deep = false,
            target,
            i = 0,
            j;

        if (typeof args[i] === "boolean")
        {
            deep = args[i];
            i++;
        }

        target = args[i];
        i++;

        for (; i < args.length; i++)
        {
            const
                source = args[i];

            if (source === null)
                continue;

            if (Array.isArray(source))
            {
                if (!Array.isArray(target))
                    throw new Error("Source was an array but the target was not");

                for (j = 0; j < source.length; j++)
                {
                    if (Array.isArray(source[j]))
                    {
                        if (!Array.isArray(target[j]))
                            target[j] = [];

                        Object.extend(deep, target[j], source[j]);
                    }
                    else if (Object.isPlainObject(source[j]))
                    {
                        if (!Object.isPlainObject(target[j]))
                            target[j] = {};

                        Object.extend(deep, target[j], source[j]);
                    }
                    else if (source[j] !== void 0)
                        target[j] = source[j];
                }
            }

            for (let property in source)
            {
                if (property === "__proto__")
                    continue;

                if (target === source[property])
                    continue;

                if (Array.isArray(source[property]))
                {
                    if (!Array.isArray(target[property]))
                        target[property] = [];

                    Object.extend(deep, target[property], source[property]);
                }
                else if (Object.isPlainObject(source[property]))
                {
                    if (!Object.isPlainObject(target[property]))
                        target[property] = {};

                    if (deep)
                        Object.extend(deep, target[property], source[property]);
                }
                else if (typeof source[property] === "function")
                {
                    if (Object.prototype.hasOwnProperty.call(source, property))
                        target[property] = source[property];
                }
                else if (source[property] !== void 0)
                    target[property] = source[property];
            }
        }

        return target;
    };
    Object.getPropertyNames = o =>
    {
        let
            result = new Set();

        while (o)
        {
            Object.getOwnPropertyNames(o).forEach(item => result.add(item));
            o = Object.getPrototypeOf(o);
        }
        return [...result];
    };
    Object.hasProperty = (o, propertyName) => Object.getPropertyNames(o).indexOf(propertyName) >= 0;
    Object.isNullOrUndefined = value => value === null || value === undefined;
    Object.isPlainObject = obj =>
    {
        return (
            obj !== null
            && typeof obj === "object"
            && obj.constructor === Object
            && Object.prototype.toString.call(obj) === "[object Object]"
        );
    };
    Object.valueEquals = (obj1, obj2) =>
    {
        if (obj1 === obj2)
            return true;

        if (!(obj1 instanceof Object) || !(obj2 instanceof Object))
            return false;

        if (obj1.constructor !== obj2.constructor)
            return false;

        for (let property in obj1)
        {
            if (!Object.prototype.hasOwnProperty.call(obj1, property))
                continue;

            if (!Object.prototype.hasOwnProperty.call(obj2, property))
                return false;

            if (obj1[property] === obj2[property])
                continue;

            if (typeof obj1[property] !== "object")
                return false;

            if (!Object.valueEquals(obj1[property], obj2[property]))
                return false;
        }

        for (let property in obj2)
        {
            if (Object.prototype.hasOwnProperty.call(obj2, property) && !Object.prototype.hasOwnProperty.call(obj1, property))
                return false;
        }

        return true;
    };
    if (!Object.setPrototypeOf)
    {
        Object.setPrototypeOf = (obj, prototype) =>
        {
            obj.__proto__ = prototype;
            return obj;
        }
    }
    if (!Object.values)
    {
        Object.values = obj => Object.keys(obj).map(e => obj[e]);
    }
    if (!Object.prototype.hasOwnProperty.call(Object.prototype, "toJson"))
    {
        Object.defineProperty(Object.prototype, "toJson", {
            value: function (replacer, space)
            {
                return JSON.stringify(this, replacer, space);
            }
        });
    }
    Object.toKeyValueArray = obj => Object.keys(obj).map(key => ({ key: key, value: obj[key] }));

    // #endregion

    // #region Promise

    Promise.public = () =>
    {
        let
            promiseResolve,
            promiseReject;

        const
            promise = new Promise((resolve, reject) =>
            {
                promiseResolve = resolve;
                promiseReject = reject;
            });

        promise.resolve = promiseResolve;
        promise.reject = promiseReject;

        return promise;
    };
    if (!Promise.prototype.finally)
    {
        Promise.prototype.finally = function (fn)
        {
            var
                onFinally = value => Promise.resolve(fn()).then(() => value);

            return (
                this
                    .then(
                        result => onFinally(result),
                        reason => onFinally(Promise.reject(reason))
                    )
            );
        };
    }
    if (!Promise.prototype.always) // Temporary while we remove jQuery.Deferred
        Promise.prototype.always = Promise.prototype.finally;

    // #endregion

    // #region String

    String.compare = (s1, s2) =>
    {
        if (s1 < s2)
            return -1;

        if (s1 > s2)
            return 1;

        return 0;
    };
    String.empty = "";
    String.format = (...args) =>
    {
        var
            s = args[0];

        args = args.skip(1);

        return s.replace(/{(\d+)}/g, (match, number) =>
        {
            if (typeof args[number] === "undefined")
                return match;

            if (args[number] === null)
                return String.empty;

            return args[number];
        });
    };
    String.formatWithHtmlEncode = (...args) =>
    {
        return String.format.apply(
            String,
            args
                .select((item, index) =>
                {
                    if (index === 0)
                        return item;

                    return (
                        item !== undefined && item !== null && item.toString
                            ? item.toString().htmlEncode()
                            : null
                    );
                })
        );
    };
    String.htmlDecode = s =>
    {
        if (s === undefined || s === null)
            return s;

        if (typeof s !== "string")
        {
            if (s.toString)
                s = s.toString();
            else
                return undefined;
        }

        return s.htmlDecode();
    };
    String.htmlEncode = s =>
    {
        if (s === undefined || s === null)
            return s;

        if (typeof s !== "string")
        {
            if (s.toString)
                s = s.toString();
            else
                return undefined;
        }

        return s.htmlEncode();
    };
    String.invertColorHexCode = (s, amplifyToBlackOrWhite) =>
    {
        if (s.indexOf("#") === -1)
            s = `#${s}`;

        if (s.length === 4)
            s = s[0] + s[1] + s[1] + s[2] + s[2] + s[3] + s[3];

        if (!String.isColorHexCode(s))
            throw new Error("String is not a color hex code");

        s = s.slice(1);

        let
            r = parseInt(s.slice(0, 2), 16),
            g = parseInt(s.slice(2, 4), 16),
            b = parseInt(s.slice(4, 6), 16);

        if (amplifyToBlackOrWhite)
            return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';

        r = (255 - r).toString(16);
        g = (255 - g).toString(16);
        b = (255 - b).toString(16);

        return "#" + r.padLeft(2, "0") + g.padLeft(2, "0") + b.padLeft(2, "0");
    };
    String.isColorHexCode = s =>
    {
        return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(s);
    };
    String.isNull = s => s === null;
    String.isNullOrEmpty = s => s === null || s === String.empty;
    String.isNullOrWhitespace = s => s === null || s.trim() === String.empty;
    String.isNullOrUndefinedOrWhitespace = s => s === undefined || String.isNullOrWhitespace(s);
    String.truncate = (s, length, elipsis) =>
    {
        s = (s || String.empty).trim();
        length = length || 10;
        elipsis = elipsis || "...";

        if (s.length <= length)
            return s;

        var
            words = s.split(" "),
            returnValue = String.empty;

        for (var i = 0; i < words.length; i++)
        {
            var
                newValue = returnValue + (returnValue.length ? " " : String.empty) + words[i];

            if (newValue.length + elipsis.length > length)
                break;

            returnValue = newValue;
        }

        return returnValue + elipsis;
    };
    String.prototype.byteLength = function ()
    {
        var
            length = this.length;

        for (var i = this.length - 1; i >= 0; i--)
        {
            var
                code = this.charCodeAt(i);

            if (code > 0x7f && code <= 0x7ff)
                length++;
            else if (code > 0x7ff && code <= 0xffff)
                length += 2;

            if (code >= 0xDC00 && code <= 0xDFFF)
                i--; // trail surrogate
        }
        return length;
    };
    String.prototype.contains = function (s)
    {
        return this.indexOf(s) >= 0;
    };
    String.prototype.endsWith = function (s, stringComparisionOptions)
    {
        if (s.length > this.length)
            return false;

        return this.substring(this.length - s.length, this.length).equals(s, stringComparisionOptions);
    };
    String.prototype.equals = function (s, stringComparisionOptions)
    {
        if (stringComparisionOptions?.ignoreCase)
            return this.toLowerCase() === s.toLowerCase();

        return String(this) === s;
    };
    String.prototype.fromDashed = function ()
    {
        if (Object.isNullOrUndefined(this))
            return this;

        return this.replace(/-(.)/g, function (match, group)
        {
            return group.toUpperCase();
        });
    };
    String.prototype.fromJson = function ()
    {
        return JSON.parse(this);
    };
    String.prototype.htmlDecode = function ()
    {
        return this
            .replace(/&quot;/g, "\"")
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&");
    };
    String.prototype.htmlEncode = function ()
    {
        return this
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/'/g, "&#39;")
            .replace(/"/g, "&quot;");
    };
    String.prototype.isEmailAddress = function ()
    {
        var
            $$input = $$.create$$({ nodeName: "input", attributes: { type: "email" } });

        $$input.val(this);

        return $$input[0].validity?.valid;
    };
    String.prototype.isGuid = function ()
    {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this);
    };
    String.prototype.isDate = function (format)
    {
        var
            result = Date.tryFromString(this, format);

        if (!result.success && format.contains("f"))
            result = Date.tryFromString(this, format.replace(/[.f]/gi, String.empty));

        return result.success;
    };
    String.prototype.isLowerCase = function ()
    {
        var primitive = this.valueOf();
        return primitive === primitive.toLowerCase();
    };
    String.prototype.isUpperCase = function ()
    {
        var primitive = this.valueOf();
        return primitive === primitive.toUpperCase();
    };
    String.prototype.padLeft = function (length, char)
    {
        var
            output = this;

        if (length > 0 && char.length > 0)
        {
            while (output.length < length)
                output = char + output;
        }

        return output;
    };
    String.prototype.padRight = function (length, char)
    {
        var
            output = this;

        if (length > 0 && char.length > 0)
        {
            while (output.length < length)
                output = output + char;
        }

        return output;
    };
    String.prototype.startsWith = function (s, stringComparisionOptions)
    {
        if (s.length > this.length)
            return false;

        return this.substring(0, s.length).equals(s, stringComparisionOptions);
    };
    String.prototype.toDashed = function ()
    {
        return this.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    };
    String.prototype.toLowerCamelCase = function ()
    {
        if (String.isNullOrEmpty(this))
            return this;

        if (!this[0].isUpperCase())
            return this;

        var
            chars = this.split(String.empty);

        for (var i = 0; i < chars.length; i++)
        {
            var
                hasNext = i + 1 < chars.length;

            if (i > 0 && hasNext && !chars[i + 1].isUpperCase())
                break;

            chars[i] = chars[i].toLowerCase();
        }

        return chars.join(String.empty);
    };
    String.prototype.toLowerCamelCasePath = function ()
    {
        if (String.isNullOrEmpty(this))
            return this;

        return (
            this
                .split(".")
                .select(item => item.toLowerCamelCase())
                .join(".")
        );
    };
    String.prototype.toUpperCamelCase = function ()
    {
        return (
            this.substring(0, 1).toUpperCase()
            + (this.length > 1 ? this.substring(1) : String.empty)
        );
    };
    String.prototype.trim = function (char)
    {
        return this.trimStart(char).trimEnd(char);
    };
    String.prototype.trimEnd = function (char)
    {
        var
            newString = this.toString();

        if (char === undefined)
            char = [" ", "\r", "\n"];

        var
            charArray = Array.isArray(char) ? char : [char];

        while (charArray.contains(newString[newString.length - 1]))
            newString = newString.substring(0, newString.length - 1);

        return newString;
    };
    String.prototype.trimStart = function (char)
    {
        var
            newString = this.toString();

        if (char === undefined)
            char = [" ", "\r", "\n"];

        var
            charArray = Array.isArray(char) ? char : [char];

        while (charArray.contains(newString[0]))
            newString = newString.substring(1);

        return newString;
    };

    // #endregion

    // #endregion

    // #region DOM Manipulation Extension

    ($$ =>
    {
        // #region Global

        $$.addClass = (element, className) =>
        {
            if (!className)
                return;

            if (element.classList?.add)
            {
                DOMTokenList.prototype.add.apply(
                    element.classList,
                    className
                        .split(" ")
                        .where(item => !!item)
                );
                return;
            }

            var
                originalClassName = element.className,
                classList = originalClassName ? originalClassName.split(" ").where(item => !!item) : [];

            if (className)
            {
                className.split(" ").where(item => !!item)
                    .where(item => !classList.contains(item))
                    .each(item => { classList.add(item); })
            }

            var
                currentClassName = classList.join(" ");

            if (currentClassName !== originalClassName)
                element.className = currentClassName;
        };
        $$.create = (nodeNameOrConfigOrConfigArray, className, text, data) =>
        {
            // config = { attributes, children, nodeName, text }

            if (typeof nodeNameOrConfigOrConfigArray === "string")
            {
                nodeNameOrConfigOrConfigArray = {
                    nodeName: nodeNameOrConfigOrConfigArray,
                    attributes: className ? { "class": className } : null,
                    text: text,
                    data: data
                };
            }

            if (Array.isArray(nodeNameOrConfigOrConfigArray))
            {
                return (
                    nodeNameOrConfigOrConfigArray
                        .map(item => $$.create(item))
                );
            }

            var
                config = nodeNameOrConfigOrConfigArray;

            if (!config.nodeName)
                return $$.createText(config.text);

            var
                element = document.createElement(config.nodeName);

            if (config.attributes)
            {
                Object
                    .keys(config.attributes)
                    .each(key => { element.setAttribute(key, config.attributes[key]); });
            }

            if (config.text !== void 0 && config.text !== null)
                element.appendChild($$.createText(config.text));

            if (config.data)
                $$.data(element, config.data);

            if (config.children)
            {
                config
                    .children
                    .each(item => { element.append(item instanceof Node ? item : $$.create(item)); });
            }

            return element;
        };
        $$.create$$ = (...args) => $$($$.create.apply(void 0, args));
        $$.createNbsp = () => $$.createText("\u00A0");
        $$.createText = text =>
        {
            return document.createTextNode(text);
        };
        $$.hasClass = (element, className) =>
        {
            if (!className)
                return false;

            if (element.classList)
                return element.classList.contains(className);

            const
                originalClassName = element.className,
                classList =
                    originalClassName
                        ? originalClassName.split(" ").where(item => !!item)
                        : [];

            return classList.contains(className);
        };
        $$.radControl = (element, control) =>
        {
            if (!control)
                return radControlMap.get(element);

            $$.addClass(element, "rad-control");
            radControlMap.set(element, control);
        };

        // #endregion

        // #region Events

        var
            waitInterval = 100,
            scrollEndTimeoutId = 0,
            scrollEndHandler = function ()
            {
                var
                    $$this = $$(this);

                if (scrollEndTimeoutId)
                    clearTimeout(scrollEndTimeoutId);

                scrollEndTimeoutId = setTimeout(() => { $$this.trigger("scrollend"); $$this = null; }, waitInterval);
            },
            resizeEndTimeoutId = 0,
            resizeEndHandler = function ()
            {
                var
                    $$this = $$(this),
                    $$element = this === window ? $$("html") : $$this;

                if (resizeEndTimeoutId)
                    clearTimeout(resizeEndTimeoutId);

                if (!$$element.hasClass("rad-state-resizing"))
                {
                    $$element.addClass("rad-state-resizing")
                    $$this.trigger("resizestart");
                }

                resizeEndTimeoutId = setTimeout(() => { $$element.removeClass("rad-state-resizing"); $$this.trigger("resizeend"); $$this = null; }, waitInterval);
            },
            swipeThreshold = 20,
            swipeStartInputCoords = null,
            swipeStartHandler = function (evt)
            {
                swipeStartInputCoords = window.eventHelper.getInputCoordinates(evt);
            },
            swipeEndHandler = function (evt)
            {
                if (swipeStartInputCoords)
                {
                    var
                        $$this = $$(this),
                        swipeEndInputCoords = window.eventHelper.getInputCoordinates(evt),
                        xDistance = Math.abs(swipeEndInputCoords.x - swipeStartInputCoords.x),
                        yDistance = Math.abs(swipeEndInputCoords.y - swipeStartInputCoords.y);

                    if (xDistance > swipeThreshold || yDistance > swipeThreshold)
                    {
                        if (xDistance >= yDistance)
                        {
                            // Horizontal
                            if (swipeEndInputCoords.x < swipeStartInputCoords.x)
                                $$this.triggerHandler("swipe", { direction: "left" });
                            else
                                $$this.triggerHandler("swipe", { direction: "right" });
                        }
                        else
                        {
                            // Vertical
                            if (swipeEndInputCoords.y < swipeStartInputCoords.y)
                                $$this.triggerHandler("swipe", { direction: "up" });
                            else
                                $$this.triggerHandler("swipe", { direction: "down" });
                        }
                    }

                    swipeStartInputCoords = null;
                }
            };

        $$.event.special.scrollend = {
            setup: function ()
            {
                $$(this).on("scroll", scrollEndHandler);
            },
            teardown: function ()
            {
                $$(this).off("scroll", scrollEndHandler);
            }
        };
        $$.event.special.resizeend = {
            setup: function ()
            {
                $$(this).on("resize", resizeEndHandler);
            },
            teardown: function ()
            {
                $$(this).off("resize", resizeEndHandler);
            }
        };
        $$.event.special.swipe = {
            setup: function ()
            {
                const
                    $$this = $$(this);

                $$this.on("mousedown touchstart", swipeStartHandler);
                $$this.on("mouseup touchend", swipeEndHandler);
            },
            teardown: function ()
            {
                const
                    $$this = $$(this);

                $$this.off("mousedown touchstart", swipeStartHandler);
                $$this.off("mouseup touchend", swipeEndHandler);
            }
        };

        // #endregion

        // #region Methods

        const
            radControlMap = new WeakMap();

        $$.fn.changeTagName = function (tagName)
        {
            for (let i = 0; i < this.length; i++)
            {
                const
                    node = this[i];

                if (!(node instanceof Element))
                    continue;

                if (node.tagName === tagName.toUpperCase())
                    continue;

                const
                    attributes = {};

                for (let attribute of node.attributes)
                    attributes[attribute.nodeName] = attribute.value;

                const
                    newElement = document.createElement(tagName);

                if (attributes)
                {
                    Object
                        .keys(attributes)
                        .forEach(item => { newElement.setAttribute(item, attributes[item]); });
                }

                while (node.firstChild)
                    newElement.append(node.firstChild);

                if (node.parentElement)
                    node.parentElement.insertBefore(newElement, node);

                node.remove();

                this[i] = newElement;
            }
            return this;
        };
        $$.fn.dataGet = function (keyOrObj, value)
        {
            return this.data(keyOrObj, value);
        };
        $$.fn.dataRemove = function (...args)
        {
            this.removeData.apply(this, args);
        };
        $$.fn.dataSet = function (keyOrObj, value)
        {
            return this.data(keyOrObj, value);
        };
        $$.fn.hasAnyClass = function (classNameArray)
        {
            for (var i = 0; i < classNameArray.length; i++)
            {
                if (this.hasClass(classNameArray[i]))
                    return true;
            }

            return false;
        };
        $$.fn.radControl = function (control)
        {
            if (!control)
            {
                if (!this.length)
                    return;

                return $$.radControl(this[0]);
            }

            $$.radControl(this[0], control);
            
            return this;
        };
        $$.fn.radControls = function (selector)
        {
            return (
                Array.prototype.filter.call(
                    this
                        .find(selector)
                        .map(item => $$.radControl(item)),
                    item => !!item
                )
            );
        };
        $$.fn.removeRadControl = function ()
        {
            for (let node of this)
                radControlMap.delete(node);
        };
        $$.fn.reverse = [].reverse;

        // #endregion

        // #region Semantic UI / Fomantic UI Support

        ["accordion", "checkbox", "dropdown", "popup", "progress", "sidebar", "tab", "transition"]
            .forEach(item =>
            {
                $$.fn[item] = function (...args)
                {
                    const
                        $this = $(this);

                    return $this[item].apply($this, args);
                };
            });

        // #endregion

    })($$);

    // #endregion

    // #region Class Factory

    (() =>
    {
        if (String.empty === undefined)
            String.empty = "";

        if (String.prototype.fromJson === undefined)
        {
            String.prototype.fromJson = function ()
            {
                return JSON.parse(this);
            };
        }

        function cloneObject(obj)
        {
            if (typeof obj === "undefined")
                return undefined;

            if (obj === null)
                return null;

            return obj.toJson().fromJson();
        }

        if (!Object.prototype.hasOwnProperty.call(Object.prototype, "toJson"))
        {
            Object.defineProperty(Object.prototype, "toJson", {
                value: function (replacer, space)
                {
                    return JSON.stringify(this, replacer, space);
                }
            });
        }

        const
            bindEvents = self =>
            {
                for (let boundEvent of self[".classDefinition"].boundEvents)
                {
                    if (self[boundEvent.target])
                        self.on(boundEvent.name, { self: self }, self[boundEvent.target]);
                }
            },
            updatePropertyBoundEvents = (self, propertyDefinition, currentValue, originalValue) =>
            {
                if (!propertyDefinition.boundEvents)
                    return;

                for (let boundEvent of propertyDefinition.boundEvents)
                {
                    if (originalValue && self[boundEvent.target])
                        originalValue.off(boundEvent.name, { self: self }, self[boundEvent.target]);

                    if (currentValue && self[boundEvent.target])
                        currentValue.on(boundEvent.name, { self: self }, self[boundEvent.target]);
                }
            },
            removePropertyBoundEvents = self =>
            {
                for (let property of self[".classDefinition"].properties)
                {
                    if (!property.boundEvents)
                        continue;

                    const
                        value = self[".properties"][property.name];

                    for (let boundEvent of property.boundEvents)
                    {
                        if (value && self[boundEvent.target])
                            value.off(boundEvent.name, { self: self }, self[boundEvent.target]);
                    }
                }
            };

        function RadObject()
        {
            this[".debounceTimeouts"] = {};
            this[".eventHandlerTarget"] = $$(this);
        }
        RadObject.prototype = {
            __isConstructing: function ()
            {
                return !!this[".constructing"];
            },
            __propertyGet: function (name)
            {
                if (this[".disposed"])
                    return null;

                return (
                    this[".properties"][name] !== undefined
                        ? this[".properties"][name]
                        : null
                );
            },
            __propertySet: function (name, value)
            {
                if (this[".disposed"])
                    return false;

                var
                    currentValue = this.__propertyGet(name);

                if (currentValue === value)
                    return false;

                this[".properties"][name] = value;

                return true;
            },
            _dispose: function ()
            {
                /* Intentionally empty */
            },
            debounceClear: function (key)
            {
                if (!this[".debounceTimeouts"][key])
                    return;

                clearTimeout(this[".debounceTimeouts"][key]);
                delete this[".debounceTimeouts"][key];
            },
            debounce: function (key, fn, ms)
            {
                var
                    self = this;

                self.debounceClear(key);

                this[".debounceTimeouts"][key] =
                    setTimeout(() =>
                    {
                        self.debounceClear(key);
                        fn && fn();
                    }, ms);
            },
            dispose: function ()
            {
                if (this[".disposed"])
                    return;

                if (this[".disposing"])
                {
                    console.error("Object already disposing");
                    return;
                }

                this[".disposing"] = true;

                removePropertyBoundEvents(this);
                this.off();

                this._dispose();

                for (let property in this)
                    delete this[property];

                this[".disposed"] = true;
            },
            getEventHandlerTarget: function ()
            {
                return this[".eventHandlerTarget"];
            },
            off: function (events, ...args)
            {
                if (!events)
                    return;

                const
                    eventNames = events.split(" ").filter(item => !!item);

                for (let eventName of eventNames)
                {
                    const
                        $$target = this.getEventHandlerTarget(eventName);

                    if (!$$target)
                        return;

                    $$target.off(eventName, ...args);
                }
            },
            on: function (events, ...args)
            {
                if (!events)
                    return;

                const
                    eventNames = events.split(" ").filter(item => !!item);

                for (let eventName of eventNames)
                {
                    const
                        $$target = this.getEventHandlerTarget(eventName);

                    if (!$$target)
                        return;

                    $$target.on(eventName, ...args);
                }
            },
            setProperties: function (properties)
            {
                var
                    property, i;

                for (property in properties)
                {
                    for (i = 0; i < this[".classDefinition"].properties.length; i++)
                    {
                        if (this[".classDefinition"].properties[i].name === property)
                        {
                            this[classFactory.createPropertySetterName(property)](properties[property]);
                            break;
                        }
                    }
                }

                return this;
            },
            trigger: function (eventName, eventData)
            {
                const
                    $$target = this.getEventHandlerTarget(eventName);

                if (!$$target)
                    return;

                $$target.trigger(eventName, eventData);
            },
            triggerHandler: function (eventName, eventData)
            {
                const
                    $$target = this.getEventHandlerTarget(eventName);

                if (!$$target)
                    return;

                $$target.triggerHandler(eventName, eventData);
            }
        };
        window.RadObject = RadObject;

        function MixinDefinition()
        {
        }
        MixinDefinition.prototype = {
        };

        function ClassDefinition()
        {
        }
        ClassDefinition.prototype = {
            designablePropertiesGet: function () // TODO: Needs moving to subclass and a mechanism adding to extend ClassDefinition
            {
                return (
                    this.propertiesWithAttributesGet()
                        .where(item => !!item.designer)
                );
            },
            implementsMixin: function (mixin)
            {
                var
                    i,
                    currentClassDefinition = this;

                while (currentClassDefinition)
                {
                    if (currentClassDefinition.mixins)
                    {
                        for (i = 0; i < currentClassDefinition.mixins.length; i++)
                        {
                            if (currentClassDefinition.mixins[i] === mixin)
                                return true;
                        }
                    }

                    currentClassDefinition = currentClassDefinition.superClassDefinition;
                }

                return false;
            },
            inheritsClassDefinition: function (classDefinition)
            {
                if (!classDefinition)
                    return false;

                var
                    currentClassDefinition = this;

                while (currentClassDefinition)
                {
                    if (currentClassDefinition === classDefinition)
                        return true;

                    currentClassDefinition = currentClassDefinition.superClassDefinition;
                }

                return false;
            },
            propertiesWithAttributesGet: function ()
            {
                var
                    properties = cloneObject(this.properties), i, j, property;

                for (i = 0; i < properties.length; i++)
                {
                    for (j = 0; j < this.propertyAttributes.length; j++)
                    {
                        if (this.propertyAttributes[j].propertyName === properties[i].name)
                        {
                            for (property in this.propertyAttributes[j])
                            {
                                if (property === "propertyName" || property === "name")
                                    continue;

                                properties[i][property] =
                                    this.propertyAttributes[j][property]
                                        ? cloneObject(this.propertyAttributes[j][property])
                                        : null;
                            }
                            break;
                        }
                    }
                }

                return properties;
            }
        };

        var ClassFactory = function ()
        {
            this.classDefinitions = [];
            this.propertyDefaultOverrides = [];
        };
        ClassFactory.prototype = {
            applyMixinsToProperties: function (classDefinition, mixins)
            {
                if (!classDefinition || !mixins)
                    return;

                var
                    i, j, k, propertyIndex;

                if (!classDefinition.properties)
                    classDefinition.properties = [];

                for (i = 0; i < mixins.length; i++)
                {
                    if (mixins[i].properties)
                    {
                        for (j = 0; j < mixins[i].properties.length; j++)
                        {
                            propertyIndex = -1;

                            for (k = 0; k < classDefinition.properties.length; k++)
                            {
                                if (classDefinition.properties[k].name === mixins[i].properties[j].name)
                                {
                                    propertyIndex = k;
                                    break;
                                }
                            }

                            if (propertyIndex >= 0)
                                classDefinition.properties[propertyIndex] = mixins[i].properties[j];
                            else
                                classDefinition.properties.push(mixins[i].properties[j]);
                        }
                    }
                }
            },
            applyMixinsToPropertyAttributes: function (classDefinition, mixins)
            {
                if (!classDefinition || !mixins)
                    return;

                var
                    i;

                for (i = 0; i < mixins.length; i++)
                    classFactory.combineClassDefinitonPropertyAttributes(classDefinition, mixins[i]);
            },
            applyMixinsToPrototype: function (prototype, mixins)
            {
                var
                    i, property;

                if (mixins)
                {
                    for (i = 0; i < mixins.length; i++)
                    {
                        if (mixins[i].prototype)
                        {
                            for (property in mixins[i].prototype)
                                prototype[property] = mixins[i].prototype[property];
                        }
                    }
                }

                return prototype;
            },
            checkPropertyValueType: function (propertyDefinition, value)
            {
                if (value === null)
                    return;

                if (propertyDefinition.type === "object")
                    return;

                var
                    valueType = this.getVariableType(value);

                if (valueType === propertyDefinition.type)
                    return;

                if (valueType === "int" && propertyDefinition.type === "float")
                    return;

                switch (propertyDefinition.type)
                {
                    case "array":
                    case "boolean":
                    case "date":
                    case "float":
                    case "function":
                    case "int":
                    case "string":
                        throw new Error(String.format("Cannot convert \"{0}\" to \"{1}\".", valueType, propertyDefinition.type));
                }

                var
                    classConstructor = this.getObjectByPath({ path: propertyDefinition.type });

                if (!classConstructor)
                    throw new Error(String.format("Unknown type \"{0}\".", propertyDefinition.type));

                if (!(value instanceof classConstructor))
                    throw new Error(String.format("Cannot convert \"{0}\" to \"{1}\".", valueType, propertyDefinition.type));
            },
            classDefinitionIsAssignableFrom: function (instanceOrClassOrClassPathOrClassDefinition, assignableFromInstanceOrClassOrClassPathOrClassDefinition)
            {
                var
                    classDefinition = this.getClassDefinition(instanceOrClassOrClassPathOrClassDefinition),
                    assignableFrom = this.getClassDefinition(assignableFromInstanceOrClassOrClassPathOrClassDefinition),
                    currentClassDefinition = assignableFrom;

                while (currentClassDefinition)
                {
                    if (currentClassDefinition === classDefinition)
                        return true;

                    currentClassDefinition = currentClassDefinition.superClassDefinition;
                }

                return false;
            },
            classDefinitionIsAssignableTo: function (instanceOrClassOrClassPathOrClassDefinition, assignableToInstanceOrClassOrClassPathOrClassDefinition)
            {
                return this.classDefinitionIsAssignableFrom(assignableToInstanceOrClassOrClassPathOrClassDefinition, instanceOrClassOrClassPathOrClassDefinition);
            },
            combineClassDefinitonBoundEvents: function (classDefinition1, classDefinition2)
            {
                if (!classDefinition1 || !classDefinition2)
                    return;

                for (let boundEvent of classDefinition2.boundEvents)
                {
                    let
                        existingBoundEventIndex = -1;

                    for (let property of classDefinition1.properties)
                    {
                        if (property.name === boundEvent.name)
                        {
                            existingBoundEventIndex = j;
                            break;
                        }
                    }

                    if (existingBoundEventIndex > -1 && !boundEvent.override)
                    {
                        console.error(
                            String.format(
                                "Bound event \"{0}\" hides an inherited bound event with the same name from \"{1}\". Please use \"override: true\" to override.",
                                boundEvent.name,
                                classDefinition1.superClassDefinition?.classFullName || "anonymous"
                            )
                        );
                    }

                    if (existingBoundEventIndex === -1 && boundEvent.override)
                    {
                        console.error(
                            String.format(
                                "No bound event \"{0}\" found on \"{1}\" to override.",
                                boundEvent.name,
                                classDefinition1.superClassDefinition?.classFullName || "anonymous"
                            )
                        );
                    }

                    if (existingBoundEventIndex > -1)
                        classDefinition1.boundEvents[existingBoundEventIndex] = boundEvent;
                    else
                        classDefinition1.boundEvents.push(boundEvent);
                }
            },
            combineClassDefinitonProperties: function (classDefinition1, classDefinition2)
            {
                if (!classDefinition1 || !classDefinition2)
                    return;

                for (var i = 0; i < classDefinition2.properties.length; i++)
                {
                    var
                        propertyDefinition = classDefinition2.properties[i];

                    if (!propertyDefinition.type)
                        propertyDefinition.type = "object";

                    var
                        existingPropertyDefinitionIndex = -1;

                    for (var j = 0; j < classDefinition1.properties.length; j++)
                    {
                        if (classDefinition1.properties[j].name === propertyDefinition.name)
                        {
                            existingPropertyDefinitionIndex = j;
                            break;
                        }
                    }

                    if (existingPropertyDefinitionIndex > -1 && !propertyDefinition.override)
                    {
                        console.error(
                            String.format(
                                "Property \"{0}\" hides an inherited property of the same name from \"{1}\". Please use \"override: true\" to override.",
                                propertyDefinition.name,
                                classDefinition1.superClassDefinition?.classFullName || "anonymous"
                            )
                        );
                    }

                    if (existingPropertyDefinitionIndex === -1 && propertyDefinition.override)
                    {
                        console.error(
                            String.format(
                                "No property \"{0}\" found on \"{1}\" to override.",
                                propertyDefinition.name,
                                classDefinition1.superClassDefinition?.classFullName || "anonymous"
                            )
                        );
                    }

                    if (existingPropertyDefinitionIndex > -1)
                        classDefinition1.properties[existingPropertyDefinitionIndex] = propertyDefinition;
                    else
                        classDefinition1.properties.push(propertyDefinition);
                }
            },
            combineClassDefinitonPropertyAttributes: function (classDefinition1, classDefinition2)
            {
                if (!classDefinition2.propertyAttributes)
                    return;

                var
                    i, j, propertyAttribute, property;

                for (i = 0; i < classDefinition2.propertyAttributes.length; i++)
                {
                    propertyAttribute = null;

                    for (j = 0; j < classDefinition1.propertyAttributes.length; j++)
                    {
                        if (classDefinition1.propertyAttributes[j].propertyName === classDefinition2.propertyAttributes[i].propertyName)
                        {
                            propertyAttribute = classDefinition1.propertyAttributes[j];
                            break;
                        }
                    }

                    if (!propertyAttribute)
                    {
                        propertyAttribute = {};
                        classDefinition1.propertyAttributes.push(propertyAttribute);
                    }

                    for (property in classDefinition2.propertyAttributes[i])
                    {
                        propertyAttribute[property] =
                            classDefinition2.propertyAttributes[i][property]
                                ? cloneObject(classDefinition2.propertyAttributes[i][property])
                                : null;
                    }
                }

            },
            compareClassOrClassPaths: function (classOrClassPath1, classOrClassPath2)
            {
                return (
                    (typeof classOrClassPath1 === "string"
                        ? this.getObjectByPath({ path: classOrClassPath1 })
                        : classOrClassPath1)
                    ===
                    (typeof classOrClassPath2 === "string"
                        ? this.getObjectByPath({ path: classOrClassPath2 })
                        : classOrClassPath2)
                );
            },
            create: function (definition)
            {
                var
                    // This instance
                    classFactory = this,
                    // The internal definition for the class we are creating
                    classDefinition = new ClassDefinition(),
                    // Iterator
                    i,
                    // Property iterator
                    property,
                    // Mixin Definition
                    mixinDefinition;

                if (definition.namespace)
                {
                    if (typeof definition.namespace === "string")
                    {
                        classDefinition.namespacePath = definition.namespace;
                        classDefinition.namespace = classFactory.getObjectByPath({ path: definition.namespace, create: true });
                    }
                    else
                    {
                        if (definition.namespace[".classDefinition"]?.classFullName)
                            classDefinition.namespacePath = definition.namespace[".classDefinition"].classFullName;

                        classDefinition.namespace = definition.namespace;
                    }
                }

                if (!classDefinition.namespace)
                    classDefinition.namespace = window;

                if (definition.name)
                {
                    if (classDefinition.namespace[definition.name])
                        console.error("An object '" + definition.name + "' already exists on the target namespace.");

                    if (classDefinition.namespacePath)
                        classDefinition.classFullName = classDefinition.namespacePath + "." + definition.name;

                    classDefinition.className = definition.name;
                }

                classDefinition.abstract =
                    definition.abstract
                        ? true
                        : false;

                if (definition.inherits)
                {
                    if (typeof definition.inherits === "string")
                    {
                        classDefinition.superClass = classFactory.getObjectByPath({ path: definition.inherits, namespace: classDefinition.namespace });

                        if (!classDefinition.superClass)
                            classDefinition.superClass = classFactory.getObjectByPath({ path: definition.inherits });

                        if (!classDefinition.superClass)
                            console.error(String.format("Super class \"{0}\" not found.", definition.inherits));
                    }
                    else
                        classDefinition.superClass = definition.inherits;

                    classDefinition.superClassDefinition = classFactory.getDefinition(classDefinition.superClass);
                }
                else
                    classDefinition.superClass = RadObject;

                classDefinition.mixins = [];

                if (definition.mixins)
                {
                    for (i = 0; i < definition.mixins.length; i++)
                    {
                        if (typeof definition.mixins[i] === "string")
                        {
                            // Look on class namespace
                            mixinDefinition = classFactory.getObjectByPath({ path: definition.mixins[i], namespace: classDefinition.namespace });

                            if (mixinDefinition)
                            {
                                classDefinition.mixins.push(mixinDefinition);
                                continue;
                            }

                            // Look on global namespace
                            mixinDefinition = classFactory.getObjectByPath({ path: definition.mixins[i] });

                            if (mixinDefinition)
                            {
                                classDefinition.mixins.push(mixinDefinition);
                                continue;
                            }

                            console.error("The mixin '" + definition.mixins[i] + "' could not be found.");
                        }

                        classDefinition.mixins.push(definition.mixins[i]);
                    }

                }

                // Properties
                classFactory.applyMixinsToProperties(definition, classDefinition.mixins);

                classDefinition.properties =
                    classDefinition.superClassDefinition
                        ? classDefinition.superClassDefinition.properties.slice(0)
                        : [];

                if (definition.properties)
                    classFactory.combineClassDefinitonProperties(classDefinition, definition);

                // Property Defaults
                classDefinition.createPropertyDefaults = definition.createPropertyDefaults ? definition.createPropertyDefaults : null;

                // Property Attributes
                if (definition.inheritPropertyAttributes === undefined)
                    definition.inheritPropertyAttributes = true;

                classDefinition.propertyAttributes =
                    classDefinition.superClassDefinition && definition.inheritPropertyAttributes
                        ? cloneObject(classDefinition.superClassDefinition.propertyAttributes)
                        : [];

                if (definition.propertyAttributes)
                    classFactory.combineClassDefinitonPropertyAttributes(classDefinition, definition);

                classFactory.applyMixinsToPropertyAttributes(classDefinition, classDefinition.mixins);

                // Bound Events
                classDefinition.boundEvents =
                    classDefinition.superClassDefinition
                        ? classDefinition.superClassDefinition.boundEvents.slice(0)
                        : [];

                if (definition.boundEvents)
                    classFactory.combineClassDefinitonBoundEvents(classDefinition, definition);

                var
                    // The prototype extension for this class
                    prototypeExtension = classFactory.applyMixinsToPrototype(definition.createPrototype ? definition.createPrototype(classDefinition.namespace) : {}, classDefinition.mixins),
                    // The full prototype object including inherited methods
                    masterPrototype = Object.create(classDefinition.superClass ? classDefinition.superClass.prototype : null),
                    // The proxy prototype that will be used to create instances, mapping this.super to the super class
                    proxyPrototype = Object.create(classDefinition.superClass.prototype),
                    // The super property (this.super)
                    superProperty = function (...args)
                    {
                        return classDefinition.superClass.apply(this, args);
                    };

                superProperty[".context"] = null;

                if (definition.properties)
                {
                    for (i = 0; i < definition.properties.length; i++)
                    {
                        const
                            propertyDefinition = definition.properties[i];

                        if (propertyDefinition.override)
                            continue;

                        if (typeof propertyDefinition === "string")
                            propertyDefinition = { name: propertyDefinition, type: "string" };
                        else if (typeof propertyDefinition !== "object")
                            console.error("Unable to process property definition.");

                        classFactory.createPropertyGetMethods(prototypeExtension, propertyDefinition);
                        classFactory.createPropertySetMethods(prototypeExtension, propertyDefinition);
                    }
                }

                for (property in prototypeExtension)
                    Object.defineProperty(masterPrototype, property, Object.getOwnPropertyDescriptor(prototypeExtension, property));

                for (property in masterPrototype)
                {
                    if (typeof masterPrototype[property] !== "function")
                    {
                        Object.defineProperty(proxyPrototype, property, Object.getOwnPropertyDescriptor(masterPrototype, property));
                        continue;
                    }

                    let
                        currentClassDefinition = classDefinition;

                    while (currentClassDefinition)
                    {
                        const
                            prototypeExtensionForSuperClass = currentClassDefinition.superClass.prototypeExtension ?? currentClassDefinition.superClass.prototype;

                        if (prototypeExtensionForSuperClass[property])
                        {
                            superProperty[property] = function (classDefinition, property)
                            {
                                return function (...args)
                                {
                                    return classDefinition.superClass.prototype[property].apply(this[".context"], args);
                                };
                            }(currentClassDefinition, property);

                            break;
                        }

                        currentClassDefinition = currentClassDefinition.superClassDefinition;
                    }

                    if (prototypeExtension[property])
                    {
                        proxyPrototype[property] = function (property)
                        {
                            return function (...args)
                            {
                                if (this[".disposed"])
                                    return;

                                if (superProperty === this.super && superProperty[".context"] === this)
                                    return masterPrototype[property].apply(this, args);

                                return classFactory.mapSuperAndCallMethod.call(this, masterPrototype[property], args, superProperty);
                            };
                        }(property);
                    }
                    else
                        proxyPrototype[property] = masterPrototype[property];
                }

                var
                    // The constructor for this class
                    constructor;

                if (definition.createConstructor)
                    constructor = definition.createConstructor(classDefinition.namespace);

                classDefinition.classConstructor = function (...args)
                {
                    if (!(this instanceof classDefinition.classConstructor))
                        return createInstance(args);

                    if (!this[".classDefinition"])
                    {
                        if (classDefinition.abstract)
                            console.error("Cannot create an instance of an abstract class.");

                        this[".classDefinition"] = classDefinition;
                        this[".properties"] = classFactory.getDefaultProperties(classDefinition, args);
                        this[".constructing"] = true;
                    }

                    let
                        currentClassDefinition = classDefinition;

                    while (currentClassDefinition)
                    {
                        if (currentClassDefinition.superClass.hasConstructor !== false)
                        {
                            currentClassDefinition.superClass.apply(this, args);
                            break;
                        }
                        currentClassDefinition = currentClassDefinition.superClassDefinition;
                    }

                    if (constructor)
                        classFactory.mapSuperAndCallMethod.call(this, constructor, args, superProperty);

                    if (classDefinition === this[".classDefinition"])
                    {
                        bindEvents(this);
                        this[".constructing"] = false;
                    }
                };

                classDefinition.classConstructor.prototype = Object.create(proxyPrototype);
                classDefinition.classConstructor.prototypeExtension = prototypeExtension;
                classDefinition.classConstructor.hasConstructor = !!constructor;

                classDefinition.classConstructor.prototype.toString = function ()
                {
                    return "[object " + (classDefinition.className ? classDefinition.className : "Object") + "]";
                };

                // Reference back to the classDefinition from the constructor
                classDefinition.classConstructor[".classDefinition"] = classDefinition;

                if (classDefinition.className)
                    classDefinition.namespace[classDefinition.className] = classDefinition.classConstructor;

                // TODO: Call all the "classCreated" methods from inherited classes
                if (definition.classCreated)
                    definition.classCreated(classDefinition.namespace, classDefinition.classConstructor);

                classDefinition.prototypeExtension = prototypeExtension;
                classFactory.classDefinitions.push(classDefinition);

                const
                    createInstance = (function ()
                    {
                        function Instance(args)
                        {
                            return classDefinition.classConstructor.apply(this, args);
                        }
                        Instance.prototype = classDefinition.classConstructor.prototype;

                        return function (args)
                        {
                            return new Instance(args);
                        }
                    })();

                return classDefinition.classConstructor;
            },
            createMixin: function (definition)
            {
                var
                    // This instance
                    classFactory = this,
                    // The internal definition for the class we are creating
                    mixinDefinition = new MixinDefinition();

                if (definition.namespace)
                {
                    if (typeof definition.namespace === "string")
                    {
                        mixinDefinition.namespacePath = definition.namespace;
                        mixinDefinition.namespace = classFactory.getObjectByPath({ path: definition.namespace, create: true });
                    }
                    else
                    {
                        if (definition.namespace[".classDefinition"]?.classFullName)
                            mixinDefinition.namespacePath = definition.namespace[".classDefinition"].classFullName;

                        mixinDefinition.namespace = definition.namespace;
                    }
                }

                if (!mixinDefinition.namespace)
                    mixinDefinition.namespace = window;

                if (definition.name)
                {
                    if (mixinDefinition.namespace[definition.name])
                        console.error("An object '" + definition.name + "' already exists on the target namespace.");

                    if (mixinDefinition.namespacePath)
                        mixinDefinition.classFullName = mixinDefinition.namespacePath + "." + definition.name;

                    mixinDefinition.name = definition.name;
                }

                mixinDefinition.properties = definition.properties;
                mixinDefinition.propertyAttributes = definition.propertyAttributes;
                mixinDefinition.prototype =
                    definition.createPrototype
                        ? definition.createPrototype(mixinDefinition.namespace)
                        : {};

                if (mixinDefinition.name)
                    mixinDefinition.namespace[mixinDefinition.name] = mixinDefinition;

                return mixinDefinition;
            },
            createPropertyGetMethods: function (prototype, propertyDefinition)
            {
                var
                    getMethodPublic = this.createPropertyGetterName(propertyDefinition.name),
                    getMethodPrivate = "_" + getMethodPublic;

                if (!Object.prototype.hasOwnProperty.call(prototype, getMethodPrivate))
                {
                    prototype[getMethodPrivate] = function ()
                    {
                        return this.__propertyGet(propertyDefinition.name);
                    };
                }

                if (!Object.prototype.hasOwnProperty.call(prototype, getMethodPublic))
                {
                    prototype[getMethodPublic] = function ()
                    {
                        return this[getMethodPrivate]();
                    };
                }
            },
            createPropertySetMethods: function (prototype, propertyDefinition)
            {
                var
                    classFactory = this,
                    setMethodPublic = this.createPropertySetterName(propertyDefinition.name),
                    setMethodPrivate = "_" + setMethodPublic,
                    changedMethod = "_" + this.createPropertyChangedName(propertyDefinition.name),
                    triggerChangeMethod = this.createPropertyTriggerChangeName(propertyDefinition.name);

                if (!Object.prototype.hasOwnProperty.call(prototype, changedMethod))
                {
                    prototype[changedMethod] = function ()
                    {
                    };
                }

                if (!Object.prototype.hasOwnProperty.call(prototype, triggerChangeMethod))
                {
                    prototype[triggerChangeMethod] = function ()
                    {
                        var
                            currentValue = this.__propertyGet(propertyDefinition.name),
                            originalValue = this.__isConstructing() ? null : currentValue;

                        return this[changedMethod]({ originalValue: originalValue, currentValue: currentValue });
                    };
                }

                if (!Object.prototype.hasOwnProperty.call(prototype, setMethodPrivate))
                {
                    prototype[setMethodPrivate] = function (value)
                    {
                        if (value === undefined)
                            return false;

                        classFactory.checkPropertyValueType(propertyDefinition, value);

                        var
                            originalValue = this.__propertyGet(propertyDefinition.name),
                            result = this.__propertySet(propertyDefinition.name, value);

                        if (result)
                        {
                            updatePropertyBoundEvents(this, propertyDefinition, value, originalValue);
                            this[changedMethod]({ currentValue: value, originalValue: originalValue });
                        }

                        return result;
                    };
                }

                if (!Object.prototype.hasOwnProperty.call(prototype, setMethodPublic))
                {
                    prototype[setMethodPublic] = function (value)
                    {
                        return this[setMethodPrivate](value);
                    };
                }
            },
            createPropertyChangedName: function (propertyName)
            {
                return propertyName + "Changed";
            },
            createPropertyGetterName: function (propertyName)
            {
                return propertyName + "Get";
            },
            createPropertySetterName: function (propertyName)
            {
                return propertyName + "Set";
            },
            createPropertyTriggerChangeName: function (propertyName)
            {
                return propertyName + "TriggerChange";
            },
            extendObject: function (obj, properties)
            {
                for (let property in properties)
                    obj[property] = properties[property];
            },
            getClassDefinition: function (instanceOrClassOrClassPathOrClassDefinition)
            {
                // Instance / Class
                if (instanceOrClassOrClassPathOrClassDefinition[".classDefinition"])
                    return instanceOrClassOrClassPathOrClassDefinition[".classDefinition"];

                // Class Definition
                if (instanceOrClassOrClassPathOrClassDefinition instanceof ClassDefinition)
                    return instanceOrClassOrClassPathOrClassDefinition;

                // Class Path
                if (typeof instanceOrClassOrClassPathOrClassDefinition === "string")
                {
                    var
                        obj = this.getObjectByPath({ path: instanceOrClassOrClassPathOrClassDefinition });

                    return obj ? obj[".classDefinition"] : null;
                }

                return null;
            },
            getClassFullNameList: function (instanceOrClassOrClassPathOrClassDefinition)
            {
                const
                    classFullNameList = [];

                let
                    classDefinition = this.getClassDefinition(instanceOrClassOrClassPathOrClassDefinition);

                while (classDefinition)
                {
                    classFullNameList.push(classDefinition.classFullName);
                    classDefinition = classDefinition.superClassDefinition;
                }

                return classFullNameList;
            },
            getDefaultProperties: function (classDefinition, constructionArguments)
            {
                var
                    stack = [],
                    currentClassDefinition = classDefinition,
                    properties = {},
                    propertyDefaultOverrideFunction;

                while (currentClassDefinition)
                {
                    if (currentClassDefinition.createPropertyDefaults)
                        stack.push(currentClassDefinition);
                    currentClassDefinition = currentClassDefinition.superClassDefinition;
                }

                while (stack.length)
                {
                    currentClassDefinition = stack.pop();
                    this.extendObject(properties, currentClassDefinition.createPropertyDefaults(currentClassDefinition.namespace));

                    propertyDefaultOverrideFunction = this.getPropertyDefaultOverrideFunction(currentClassDefinition);
                    if (propertyDefaultOverrideFunction)
                        this.extendObject(properties, propertyDefaultOverrideFunction(currentClassDefinition.namespace));
                }

                if (constructionArguments && typeof constructionArguments[0] === "object")
                    this.extendObject(properties, constructionArguments[0]);

                return properties;
            },
            getDefinition: function (classConstructor)
            {
                for (var i = 0; i < this.classDefinitions.length; i++)
                {
                    if (this.classDefinitions[i].classConstructor === classConstructor)
                        return this.classDefinitions[i];
                }
                return null;
            },
            getObjectByPath: function (options)
            {
                var
                    currentObject = options.namespace ? options.namespace : window;

                if (options.path?.length > 0)
                {
                    var
                        pathParts = options.path.split("."),
                        currentPath = String.empty;

                    if (pathParts[0] === "window")
                    {
                        pathParts.shift();

                        if (pathParts.length === 0)
                            return currentObject;
                    }

                    for (var i = 0; i < pathParts.length; i++)
                    {
                        currentPath += (currentPath.length > 0 ? "." : String.empty) + pathParts[i];

                        if (!currentObject[pathParts[i]])
                        {
                            if (!options.create)
                                return null;

                            currentObject[pathParts[i]] = {};
                        }

                        currentObject = currentObject[pathParts[i]];
                    }

                    return currentObject;
                }
            },
            getPropertyDefaultOverrideFunction: function (instanceOrClassOrClassPathOrClassDefinition)
            {
                var
                    classDefinition = this.getClassDefinition(instanceOrClassOrClassPathOrClassDefinition);

                if (!classDefinition)
                    return null;

                var
                    propertyDefaultOverride = this.propertyDefaultOverrides.firstOrDefault(item => item.classDefinition === classDefinition);

                return (
                    propertyDefaultOverride
                        ? propertyDefaultOverride.fn
                        : null
                );
            },
            getVariableType: function (variable)
            {
                var
                    variableType = typeof variable;

                switch (variableType)
                {
                    case "boolean":
                    case "function":
                    case "string":
                        return variableType;
                    case "number":
                        return (
                            variable % 1 === 0
                                ? "int"
                                : "float"
                        );
                    case "object":
                        if (Array.isArray(variable))
                            return "array";
                        if (variable instanceof RadObject)
                            return variable[".classDefinition"].classFullName;
                        if (variable instanceof Date)
                            return "date";
                        return variableType;
                }

                return null;
            },
            implementsMixin: function (instanceOrClassOrClassPathOrClassDefinition, mixin)
            {
                return this.getClassDefinition(instanceOrClassOrClassPathOrClassDefinition).implementsMixin(mixin);
            },
            mapSuperAndCallMethod: function (method, args, superProperty)
            {
                var
                    originalSuperPropertyContext,
                    originalSuperProperty,
                    result;

                originalSuperPropertyContext = superProperty[".context"];
                originalSuperProperty = this.super;

                superProperty[".context"] = this;
                this.super = superProperty;

                result = method.apply(this, args);

                superProperty[".context"] = originalSuperPropertyContext;
                this.super = originalSuperProperty;

                return result;
            },
            objectInstanceOf: function (obj, classOrClassPath)
            {
                if (typeof classOrClassPath === "string")
                {
                    var
                        classConstructor = this.getObjectByPath({ path: classOrClassPath });

                    if (!classConstructor)
                        console.error("Class '" + classOrClassPath + "' not found.");

                    return obj instanceof classConstructor;
                }

                return obj instanceof classOrClassPath;
            },
            registerPropertyDefaultOverride: function (instanceOrClassOrClassPathOrClassDefinition, fn)
            {
                var
                    classDefinition = this.getClassDefinition(instanceOrClassOrClassPathOrClassDefinition);

                if (!classDefinition)
                    console.error("Class definition not found.");

                var
                    propertyDefaultOverride = this.propertyDefaultOverrides.firstOrDefault(item => item.classDefinition === classDefinition);

                if (propertyDefaultOverride)
                    propertyDefaultOverride.fn = fn;
                else
                {
                    propertyDefaultOverride =
                    {
                        classDefinition: classDefinition,
                        fn: fn
                    };
                    this.propertyDefaultOverrides.push(propertyDefaultOverride);
                }
            }
        };
        window.classFactory = new ClassFactory();

        $$(() => { $$(document).triggerHandler("seriouslyrad.ClassFactory:registerPropertyDefaultOverrides"); });

    })();

    // #endregion

    // #region Helpers

    // Object
    classFactory.create({
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                asType: function (value, type)
                {
                    if (type === "object")
                        return value;

                    var
                        sourceType = this.typeOf(value);

                    if (sourceType === type || value === undefined || value === null)
                        return value;

                    var
                        stringValue = value.toString().toLowerCase(),
                        numberValue;

                    switch (type)
                    {
                        case "array":
                            {
                                if (sourceType === "string")
                                {
                                    var
                                        array;

                                    try { array = value.fromJson(); }
                                    catch (e) { /* Continue regardless of error */ }

                                    if (array)
                                        return array;
                                }

                                break;
                            }
                        case "boolean":
                            {
                                if (stringValue === "true" || stringValue === "1")
                                    return true;

                                if (stringValue === "false" || stringValue === "0")
                                    return false;

                                return null;
                            }
                        case "date":
                            {
                                var
                                    year,
                                    month,
                                    day,
                                    hour,
                                    minute,
                                    second,
                                    date;

                                // TODO: User String -> Date Functions
                                if (stringValue.length === 10)
                                {
                                    year = parseInt(stringValue.substr(0, 4));
                                    month = parseInt(stringValue.substr(5, 2));
                                    day = parseInt(stringValue.substr(8, 2));

                                    if (isNaN(year) || isNaN(month) || isNaN(day))
                                        return null;

                                    date = new Date(year, month - 1, day);

                                    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day)
                                        return null;

                                    return date;
                                }
                                else if (stringValue.length === 24)
                                {
                                    year = parseInt(stringValue.substr(0, 4));
                                    month = parseInt(stringValue.substr(5, 2));
                                    day = parseInt(stringValue.substr(8, 2));
                                    hour = parseInt(stringValue.substr(11, 2));
                                    minute = parseInt(stringValue.substr(14, 2));
                                    second = parseInt(stringValue.substr(17, 2));

                                    if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute) || isNaN(second))
                                        return null;

                                    date = new Date(year, month - 1, day, hour, minute, second);

                                    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day || date.getHours() !== hour || date.getMinutes() !== minute || date.getSeconds() !== second)
                                        return null;

                                    return date;
                                }
                                return null;
                            }
                        case "datestring":
                            {
                                switch (sourceType)
                                {
                                    case "date":
                                        return value.toString("yyyy-MM-dd");
                                    case "string":
                                        var
                                            dateTryFromString = Date.tryFromString(value, "yyyy-MM-ddTHH:mm:ss.fffffffZ");

                                        if (dateTryFromString.success)
                                            return dateTryFromString.date.toString("yyyy-MM-dd");
                                }
                                break;
                            }
                        case "datetimestring":
                            {
                                switch (sourceType)
                                {
                                    case "date":
                                        return value.toString("yyyy-MM-ddTHH:mm:ss.fffffffZ");
                                    case "string":
                                        if (value.isDate("yyyy-MM-ddTHH:mm:ss.fffffffZ"))
                                            return value;
                                }
                                break;
                            }
                        case "float":
                            {
                                numberValue = parseFloat(stringValue);

                                if (!isNaN(numberValue))
                                    return numberValue;

                                return null;
                            }
                        case "int":
                            {
                                numberValue = parseInt(stringValue);

                                if (!isNaN(numberValue))
                                    return numberValue;

                                return null;
                            }
                        case "string":
                            {
                                if (!String.isNullOrWhitespace(stringValue))
                                    return stringValue;

                                return null;
                            }
                        default:
                            {
                                console.error(String.format("Type '{0}' is unsupported", type));
                                return null;
                            }
                    }

                    console.error(String.format("Failed to convert value of type '{0}' to type '{0}'", sourceType, type));
                },
                classInheritsClass: function (classConstructor, classConstructorInherited)
                {
                    if (!classConstructor || !classConstructor[".classDefinition"] || !classConstructorInherited || !classConstructorInherited[".classDefinition"])
                        return false;

                    return classConstructor[".classDefinition"].inheritsClassDefinition(classConstructorInherited[".classDefinition"]);
                },
                cloneObject: function (obj)
                {
                    if (typeof obj === "undefined")
                        return undefined;

                    if (obj === null)
                        return null;

                    return obj.toJson().fromJson();
                },
                copySimpleProperties: function (source, destination, predicate)
                {
                    for (var property in source)
                    {
                        if (!Object.isNullOrUndefined(source[property]) && window.objectHelper.typeOf(source[property]) === "object")
                            continue;

                        if (!predicate || predicate(property))
                            destination[property] = source[property];
                    }
                },
                isEmpty: function (value)
                {
                    if (typeof value === "string")
                        return String.isNullOrWhitespace(value);

                    return this.isNullOrUndefined(value);
                },
                isNullOrUndefined: function (value)
                {
                    return value === undefined || value === null;
                },
                propertyValueByPathGet: function (o, path)
                {
                    var
                        obj = o;

                    path.split(".").each(item =>
                    {
                        if (obj && obj[item] !== undefined)
                            obj = obj[item];
                        else
                        {
                            obj = undefined;
                            return false;
                        }
                    });

                    return obj;
                },
                propertyValueByPathSet: function (o, path, value)
                {
                    var
                        obj = o,
                        pathParts = path.split("."),
                        changed = false;

                    pathParts.each((item, index) =>
                    {
                        if (index === pathParts.length - 1)
                        {
                            if (obj[item] !== value)
                            {
                                obj[item] = value;
                                changed = true;
                            }
                            return false;
                        }
                        else
                        {
                            if (obj[item] === undefined || obj[item] === null)
                                obj[item] = {};

                            obj = obj[item];
                        }
                    });

                    return changed;
                },
                typeOf: function (value)
                {
                    var
                        type = typeof value;

                    if (value instanceof Date)
                        return "date";

                    if (type === "object")
                    {
                        if (Array.isArray(value))
                            type = "array";
                    }

                    return type;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.objectHelper = new classConstructor();
        }
    });

    // Path
    classFactory.create({
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                getLocation: function (url)
                {
                    var
                        a = document.createElement("a");

                    a.href = url;

                    var
                        applicationRelativeUrl = null,
                        // For IE 11
                        port =
                            a.protocol === "http:" && a.port === "80" || a.protocol === "https:" && a.port === "443"
                                ? String.empty
                                : a.port,
                        pathName = a.pathname;

                    // Path name should always be at least a slash
                    // Cordova iOS start page is app://localhost (no trailing slash)
                    if (pathName === String.empty)
                        pathName = "/";

                    if (pathName.toLowerCase().startsWith(window.applicationInformation.virtualDirectory.toLowerCase()))
                        applicationRelativeUrl = pathName.substring(window.applicationInformation.virtualDirectory.length);
                    else if (a.href.startsWith("file:///")) // Cordova (Android)
                        applicationRelativeUrl = pathName.substring(1);

                    return {
                        applicationRelativeUrl: applicationRelativeUrl,
                        hash: a.hash,
                        host: a.host,
                        hostname: a.hostname,
                        href: a.href,
                        origin: a.protocol + "//" + a.hostname + (port.length ? ":" + port : String.empty),
                        pathname: pathName,
                        port: port,
                        protocol: a.protocol,
                        search: a.search
                    };
                },
                getQueryStringParameters: function (url, asObject)
                {
                    var
                        parameters = asObject ? {} : [],
                        search = this.getLocation(url).search;

                    if (search.length)
                        search = search.substring(1);

                    search.split("&").each(item =>
                    {
                        var
                            pair = item.split("=");

                        if (pair.length === 2)
                        {
                            if (asObject)
                                parameters[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                            else
                                parameters.push({ name: decodeURIComponent(pair[0]), value: decodeURIComponent(pair[1]) });
                        }

                    });

                    return parameters;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.pathHelper = new classConstructor();
        }
    });

    // Cookie
    classFactory.create({
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                create: function (name, value, days)
                {
                    var
                        expires = String.empty,
                        location = window.pathHelper.getLocation(window.location);

                    if (days)
                    {
                        var
                            date = new Date();

                        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

                        expires = "; expires=" + date.toUTCString();
                    }

                    var
                        cookie = name + "=" + value + expires + "; path=/";

                    if (location.protocol === "https:")
                        cookie += "; secure";

                    document.cookie = cookie;
                },
                "delete": function (name)
                {
                    this.create(name, String.empty, -1);
                },
                read: function (name)
                {
                    var
                        nameEQ = name + "=",
                        ca = document.cookie.split(";");

                    for (var i = 0; i < ca.length; i++)
                    {
                        var
                            c = ca[i];

                        while (c[0] === " ")
                            c = c.substring(1, c.length);

                        if (c.indexOf(nameEQ) === 0)
                            return c.substring(nameEQ.length, c.length);
                    }

                    return null;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.cookieHelper = new classConstructor();
        }
    });

    // #endregion

    // #region Guid

    window.Guid = {
        empty: "00000000-0000-0000-0000-000000000000"
    };

    // #endregion

    // #region Async Iterator

    classFactory.create({
        namespace: "seriouslyrad",
        name: "AsyncIterator",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                forEach: function (arr, fn)
                {
                    if (this.cancellationToken)
                        this.cancellationToken.isCancellationRequested = true;

                    this.cancellationToken = { isCancellationRequested: false };

                    return function (cancellationToken, arr, fn)
                    {
                        return (
                            arr.reduce(
                                (promise, item) =>
                                {
                                    return (
                                        promise
                                            .then(results =>
                                            {
                                                return new Promise((resolve, reject) =>
                                                {
                                                    setTimeout(() =>
                                                    {
                                                        if (cancellationToken.isCancellationRequested)
                                                            reject("Cancelled")

                                                        resolve([...results, fn(item)]);
                                                    });
                                                });
                                            })
                                    );
                                },
                                Promise.resolve([])
                            )
                        );
                    }(this.cancellationToken, arr, fn);
                }
            };
        }
    });

    // #endregion

    // #region Property Info

    classFactory.create({
        namespace: "seriouslyrad",
        name: "PropertyInfo",
        properties: [
            { name: "declaringType" },
            { name: "propertyType" }
        ]
    });

    // #endregion

    // #region Type Info

    classFactory.create({
        namespace: "seriouslyrad",
        name: "TypeInfo",
        properties: [
            { name: "fullName", type: "string" },
            { name: "name", type: "string" },
            { name: "namespace", type: "string" },
            { name: "properties", type: "array" },
        ]
    });

    // #endregion

    // #region Observable Array

    classFactory.create({
        namespace: "seriouslyrad",
        name: "ObservableArray",
        inherits: Array,
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _callObservableMethod: function (name, args)
                {
                    var
                        length = this.length,
                        returnValue = this.super[name].apply(this.super, args);

                    if (length !== this.length)
                        this.triggerHandler(name);

                    return returnValue;
                },

                // Public Methods
                off: function (events, selector, handler)
                {
                    $$(this).off(events, selector, handler);
                },
                on: function (events, selector, data, handler)
                {
                    $$(this).on(events, selector, data, handler);
                },
                pop: function (...args)
                {
                    return this._callObservableMethod("pop", args);
                },
                push: function (...args)
                {
                    return this._callObservableMethod("push", args);
                },
                reverse: function (...args)
                {
                    return this._callObservableMethod("reverse", args);
                },
                shift: function (...args)
                {
                    return this._callObservableMethod("shift", args);
                },
                sort: function (...args)
                {
                    return this._callObservableMethod("sort", args);
                },
                splice: function (...args)
                {
                    return this._callObservableMethod("splice", args);
                },
                trigger: function (eventName, eventData)
                {
                    $$(this).trigger(eventName, eventData);
                },
                triggerHandler: function (eventName, eventData)
                {
                    $$(this).triggerHandler(eventName, eventData);
                },
                unshift: function (...args)
                {
                    return this._callObservableMethod("unshift", args);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.fromArray = array =>
            {
                var
                    observableArray = new classConstructor();

                if (array)
                    observableArray.push.apply(observableArray, array.select(item => item ? window.objectHelper.cloneObject(item) : null));

                return observableArray;
            };
        }
    });

    // #endregion

    // #region Data Source

    // Data Source
    classFactory.create({
        namespace: "seriouslyrad.data",
        name: "DataSource",
        properties: [
            { name: "data" },
            { name: "dataOriginal" },
            { name: "validationErrors" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                // Trigger Property Changes
                this.dataTriggerChange();
                this.validationErrorsTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _dataChanged: function (change)
                {
                    if (change.currentValue instanceof seriouslyrad.ObservableArray)
                        this.dataOriginalSet(change.currentValue ? seriouslyrad.ObservableArray.fromArray(change.currentValue) : null);
                    else
                        this.dataOriginalSet(change.currentValue ? window.objectHelper.cloneObject(change.currentValue) : null);
                },
                _validationErrorsChanged: function (change)
                {
                    this.triggerHandler("validationErrorsChanged", change);
                },

                // Public Methods
                acceptChanges: function ()
                {
                    // TODO: expand to handled nested objects
                    window.objectHelper.copySimpleProperties(this.dataGet(), this.dataOriginalGet());
                },
                propertyValueByPathGet: function (path)
                {
                    var
                        data = this.dataGet();

                    if (!data)
                        console.error("The data source contains no data.");

                    return window.objectHelper.propertyValueByPathGet(data, path);
                },
                propertyValueByPathSet: function (path, value, inhibitEvent)
                {
                    var
                        data = this.dataGet();

                    if (!data)
                        console.error("The data source contains no data.");

                    var
                        originalValue = this.propertyValueByPathGet(path);

                    if (window.objectHelper.propertyValueByPathSet(data, path, value))
                    {
                        if (!inhibitEvent)
                        {
                            this.triggerHandler("propertyValueChanged", { dataSource: this, path: path, originalValue: originalValue, currentValue: this.propertyValueByPathGet(path) });
                            return true;
                        }
                    }

                    return false;
                },
                revertChanges: function ()
                {
                    // TODO: expand to handled nested objects
                    var
                        dataOriginal = this.dataOriginalGet();

                    for (var property in dataOriginal)
                    {
                        if (!Object.isNullOrUndefined(dataOriginal[property]) && window.objectHelper.typeOf(dataOriginal[property]) === "object")
                            continue;

                        this.propertyValueByPathSet(property, dataOriginal[property]);
                    }
                }
            };
        }
    });

    // #endregion

    // #region Comparers

    // Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "PropertyComparer",
        abstract: true,
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    console.error("Not implemented.");
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.propertyComparers = [];

            $$(() =>
            {
                $$(document).trigger("seriouslyrad.logicevaluation.PropertyComparer:registerComparers", (id, description, instance, operator) =>
                {
                    classConstructor.propertyComparers.push({ id: id, description: description, instance: instance, operator: operator });
                });
            });
        }
    });

    // Equals Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "EqualsPropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return Object.compare(propertyValue, constantValue) === 0;
                }
            };
        }
    });

    // Greater Than Or Equal To Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "GreaterThanOrEqualToPropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return Object.compare(propertyValue, constantValue) >= 0;
                }
            };
        }
    });

    // Greater Than Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "GreaterThanPropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return Object.compare(propertyValue, constantValue) > 0;
                }
            };
        }
    });

    // Has No Value Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "HasNoValuePropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return propertyValue === undefined || propertyValue === null || String.isNullOrWhitespace(propertyValue.toString());
                }
            };
        }
    });

    // Has Value Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "HasValuePropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return propertyValue !== undefined && propertyValue !== null && !String.isNullOrWhitespace(propertyValue.toString());
                }
            };
        }
    });

    // Less Than Or Equal To Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "LessThanOrEqualToPropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return Object.compare(propertyValue, constantValue) <= 0;
                }
            };
        }
    });

    // Less Than Property Comparer
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "LessThanPropertyComparer",
        inherits: "PropertyComparer",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                compare: function (propertyValue, constantValue)
                {
                    return Object.compare(propertyValue, constantValue) < 0;
                }
            };
        }
    });

    // TODO: MEF!
    $$(document).on("seriouslyrad.logicevaluation.PropertyComparer:registerComparers", (evt, registerComparerCallback) =>
    {
        registerComparerCallback("d79b155a-56a3-41dd-870a-ecf83a0740c5", "Equals", new seriouslyrad.logicevaluation.EqualsPropertyComparer(), "=");
        registerComparerCallback("8381ff5c-7a3e-4672-b251-a99eb41447c3", "Greater Than Or Equal To", new seriouslyrad.logicevaluation.GreaterThanOrEqualToPropertyComparer(), ">=");
        registerComparerCallback("b2604f44-b29a-40d0-afe6-9bf64c171149", "Greater Than", new seriouslyrad.logicevaluation.GreaterThanPropertyComparer(), ">");
        registerComparerCallback("17120013-8fbc-4bf4-b33b-5e19020a598a", "Has No Value", new seriouslyrad.logicevaluation.HasNoValuePropertyComparer(), "Has No Value");
        registerComparerCallback("b1077685-1c05-4865-b95d-cf7542071813", "Has Value", new seriouslyrad.logicevaluation.HasValuePropertyComparer(), "Has Value");
        registerComparerCallback("92221c2c-73c5-4efd-b195-8fd77ca1c9d7", "Less Than Or Equal To", new seriouslyrad.logicevaluation.LessThanOrEqualToPropertyComparer(), "<=");
        registerComparerCallback("dee729b7-0b1f-4ae9-8b3a-5aff2981242a", "Less Than", new seriouslyrad.logicevaluation.LessThanPropertyComparer(), "<");
    });

    // #endregion

    // #region Evaluators

    // Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "Evaluator",
        abstract: true,
        properties: [
            { name: "context" },
            { name: "state" },
            { name: "type", type: "string" },
            { name: "value", type: "boolean" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.typeSet(namespace.Evaluator.getEvaluatorRegistration(this[".classDefinition"].classConstructor).dataType);

                // Trigger Property Changes
                this.valueTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    this.evaluate();
                },
                _stateChanged: function (change)
                {
                    this.evaluate();
                },
                _valueChanged: function (change)
                {
                    this.triggerHandler("valueChanged", change);
                },

                // Public Methods
                clone: function ()
                {
                    return namespace.Evaluator.fromDataObject(this.serialize());
                },
                evaluate: function ()
                {
                    console.error("Not implemented.");
                },
                serialize: function ()
                {
                    // TODO: rename "toDataObject" / spit out all properties

                    return {
                        type: this.typeGet()
                    };
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            var
                registeredEvaluators = [];

            classConstructor.getEvaluatorRegistration = classConstructor =>
            {
                var
                    evaluatorRegistration = registeredEvaluators.firstOrDefault(item => item.classConstructor === classConstructor);

                if (evaluatorRegistration === null)
                    console.error(String.format("Evaluator \"{0}\" has not been registered", classConstructor[".classDefinition"].classFullName));

                return evaluatorRegistration;
            };
            classConstructor.fromDataObject = (dataObject, context, onValueChanged) =>
            {
                var
                    registeredEvaluator = registeredEvaluators.first(item => item.dataType === dataObject.type),
                    constructionArguments = Object.extend({}, dataObject, { context: context });

                return new registeredEvaluator.classConstructor(constructionArguments);
            };

            $$(() =>
            {
                $$(document).trigger("seriouslyrad.logicevaluation.Evaluator:RegisterEvaluators", (classConstructor, dataType) =>
                {
                    registeredEvaluators.push({ classConstructor: classConstructor, dataType: dataType });
                });
            });
        }
    });

    // Evaluator Wrapper
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "EvaluatorWrapper",
        inherits: "Evaluator",
        abstract: true,
        properties: [
            { name: "evaluator" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    evaluator = this.evaluatorGet();

                if (evaluator && !(evaluator instanceof namespace.Evaluator))
                    this.evaluatorSet(namespace.Evaluator.fromDataObject(evaluator));
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    var
                        evaluator = this.evaluatorGet();

                    if (evaluator)
                        evaluator.contextSet(change.currentValue);

                    this.super._contextChanged();
                },
                _evaluatorChanged: function (change)
                {
                    if (change.originalValue && change.originalValue instanceof namespace.Evaluator)
                    {
                        change.originalValue.off("valueChanged", { self: this }, this.onEvaluatorValueChanged);
                        change.originalValue.contextSet(null);
                    }

                    if (change.currentValue && change.currentValue instanceof namespace.Evaluator)
                    {
                        change.currentValue.on("valueChanged", { self: this }, this.onEvaluatorValueChanged);
                        change.currentValue.contextSet(this.contextGet());
                    }

                    this.evaluate();
                },

                // Public Methods
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize(),
                        evaluator = this.evaluatorGet();

                    dataObject.evaluator =
                        evaluator
                            ? evaluator.serialize()
                            : null;

                    return dataObject;
                },

                // Event Handlers
                onEvaluatorValueChanged: function (evt, eventData)
                {
                    evt.data.self.evaluate();
                }
            };
        }
    });

    // Evaluator List
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "EvaluatorList",
        inherits: "Evaluator",
        abstract: true,
        properties: [
            { name: "evaluators", type: "array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                evaluators: []
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    evaluators = this.evaluatorsGet();

                this.evaluatorsSet([]);

                for (var i = 0; i < evaluators.length; i++)
                {
                    if (evaluators[i] instanceof namespace.Evaluator)
                        this.addEvaluator(evaluators[i]);
                    else
                        this.addEvaluator(namespace.Evaluator.fromDataObject(evaluators[i], this.contextGet()));
                }
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    this.evaluatorsGet().each(item => { item.contextSet(change.currentValue); });
                    this.super._contextChanged(change);
                },
                _stateChanged: function (change)
                {
                    this.evaluatorsGet().each(item => { item.stateSet(change.currentValue); });
                    this.super._stateChanged(change);
                },
                
                // Public Methods
                addEvaluator: function (evaluator)
                {
                    evaluator.on("valueChanged", { self: this }, this.onEvaluatorValueChanged);
                    evaluator.contextSet(this.contextGet());
                    this.evaluatorsGet().push(evaluator);
                    this.evaluate();
                },
                removeEvaluator: function (evaluator)
                {
                    var
                        evaluators = this.evaluatorsGet(),
                        indexOfEvaluator = evaluators.indexOf(evaluator);

                    if (indexOfEvaluator >= 0)
                    {
                        evaluators[indexOfEvaluator].off("valueChanged", { self: this }, this.onEvaluatorValueChanged);
                        evaluators[indexOfEvaluator].contextSet(null);
                        this.evaluatorsSet(evaluators.splice(indexOfEvaluator, 1));
                        this.evaluate();
                    }
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize(),
                        evaluators = this.evaluatorsGet();

                    dataObject.evaluators =
                        evaluators
                            ? evaluators.select(item => item.serialize())
                            : null;

                    return dataObject;
                },

                // Event Handlers
                onEvaluatorValueChanged: function (evt, eventData)
                {
                    evt.data.self.evaluate();
                }
            };
        }
    });

    // And Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "AndEvaluator",
        inherits: "EvaluatorList",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        evaluators = this.evaluatorsGet(),
                        value = true;

                    if (evaluators?.length)
                    {
                        for (var i = 0; i < evaluators.length; i++)
                        {
                            if (!evaluators[i].valueGet())
                            {
                                value = false;
                                break;
                            }
                        }
                    }

                    this.valueSet(value);

                    return value;
                }
            };
        }
    });

    // Not Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "NotEvaluator",
        inherits: "EvaluatorWrapper",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        evaluator = this.evaluatorGet();

                    if (!evaluator)
                        return false;

                    var
                        value = !evaluator.valueGet();

                    this.valueSet(value);

                    return value;
                }
            };
        }
    });

    // Or Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "OrEvaluator",
        inherits: "EvaluatorList",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        evaluators = this.evaluatorsGet(),
                        value = false;

                    if (evaluators?.length)
                    {
                        for (var i = 0; i < evaluators.length; i++)
                        {
                            if (evaluators[i].valueGet())
                            {
                                value = true;
                                break;
                            }
                        }
                    }

                    this.valueSet(value);

                    return value;
                }
            };
        }
    });

    // Property Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "PropertyEvaluator",
        inherits: "Evaluator",
        properties: [
            { name: "comparerId", type: "string" },
            { name: "dataSource" },
            { name: "propertyName", type: "string" },
            { name: "propertyValue" }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("dataSourceChanged", { self: this }, this.onContextDataSourceChanged);

                    if (change.currentValue)
                        change.currentValue.on("dataSourceChanged", { self: this }, this.onContextDataSourceChanged);

                    this.onContextDataSourceChanged({ data: { self: this } }, { currentValue: change.currentValue ? change.currentValue.dataSourceGet() : null });
                },
                _dataSourceChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);

                    if (change.currentValue)
                        change.currentValue.on("propertyValueChanged", { self: this }, this.onDataSourcePropertyValueChanged);

                    this.evaluate();
                },

                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        self = this,
                        context = self.contextGet();

                    if (!context)
                        console.error("A context is required.");

                    if (!context.dataSourceGet)
                        console.error("The context must contain a data source.");

                    var
                        dataSource = context.dataSourceGet();

                    if (!dataSource)
                        console.error("The context data source is not available.");

                    var
                        data = dataSource.dataGet();

                    if (!data)
                        console.error("The context data source contains no data.");

                    var
                        comparerId = self.comparerIdGet(),
                        comparer = namespace.PropertyComparer.propertyComparers.single(item => item.id === comparerId).instance;

                    if (!comparer)
                        console.error(String.format("The property comparer with id \"{0}\" was not found.", comparerId));

                    var
                        propertyValue = this.propertyValueGet();

                    // TODO: BODGE! Recode this!
                    if (propertyValue === "true")
                        propertyValue = true;
                    else if (propertyValue === "false")
                        propertyValue = false;

                    var
                        value = comparer.compare(dataSource.propertyValueByPathGet(this.propertyNameGet().toLowerCamelCase()), propertyValue);

                    this.valueSet(value);

                    return value;
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize();

                    dataObject.comparerId = this.comparerIdGet() || null;
                    dataObject.propertyName = this.propertyNameGet() || null;
                    dataObject.propertyValue = this.propertyValueGet() || null;

                    return dataObject;
                },

                // Event Handlers
                onContextDataSourceChanged: function (evt, changeInfo)
                {
                    evt.data.self.dataSourceSet(changeInfo.currentValue);
                },
                onDataSourcePropertyValueChanged: function (evt, change)
                {
                    var
                        self = evt.data.self;

                    if (change.path === self.propertyNameGet().toLowerCamelCase())
                        self.evaluate();
                }
            };
        }
    });

    // True Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "TrueEvaluator",
        inherits: "Evaluator",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        value = true;

                    this.valueSet(value);

                    return value;
                }
            };
        }
    });

    // Permission Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "PermissionEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        properties: [
            { name: "entityName", type: "string" },
            { name: "e", type: "string" },
            { name: "permission", type: "int" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                $$(document).on("seriouslyrad.ui.Application:Authenticated", { self: this }, this.onAuthenticated);
                // this causes an exception on log out - commented out for now (this is the least important of these scenarios)
                //$$(document).on("seriouslyrad.ui.Application:Unauthenticated", { self: this }, this.onUnauthenticatedChanged);
                $$(document).on("seriouslyrad.PermissionCache:PermissionsChanged", { self: this }, this.onPermissionsChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        value = false;

                    if (window.application?.permissionCache && window.application.authenticatedGet())
                        value = window.application.permissionCache.hasPermissionForEntity(this.entityNameGet(), this.permissionGet());

                    this.valueSet(value);

                    return value;
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize();

                    dataObject.entityName = this.entityNameGet() || null;
                    dataObject.permission = this.permissionGet() || null;

                    return dataObject;
                },

                // Event Handlers
                onAuthenticated: function (evt)
                {
                    evt.data.self.evaluate();
                },
                onPermissionsChanged: function (evt)
                {
                    evt.data.self.evaluate();
                },
                onUnauthenticated: function (evt)
                {
                    evt.data.self.evaluate();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.permissionLevels = {};
            $$(() => { $$(document).trigger("seriouslyrad.logicevaluation.PermissionEvaluator:registerPermissionLevels", classConstructor.permissionLevels); });
        }
    });

    // Property Permission Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "PropertyPermissionEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        properties: [
            { name: "entityName", type: "string" },
            { name: "entityPropertyName", type: "string" },
            { name: "permission", type: "int" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                permission: 2
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                $$(document).on("seriouslyrad.PermissionCache:PermissionsChanged", { self: this }, this.onPermissionsChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    if (change.currentValue)
                    {
                        if (change.currentValue.pageGet)
                        {
                            var
                                page = change.currentValue.pageGet();

                            if (page.entityNameGet)
                                this.entityNameSet(page.entityNameGet());
                        }

                        if (change.currentValue.dataSourcePropertyGet)
                            this.entityPropertyNameSet(change.currentValue.dataSourcePropertyGet());
                    }

                    this.super._contextChanged(change);
                },

                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        value = false,
                        entityName = this.entityNameGet(),
                        entityPropertyName = this.entityPropertyNameGet();

                    if (entityName && entityPropertyName)
                    {
                        if (window.application?.permissionCache)
                            value = window.application.permissionCache.hasPermissionForEntityProperty(entityName, entityPropertyName, this.permissionGet());
                    }
                    else
                        value = true; // Default true

                    this.valueSet(value);

                    return value;
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize();

                    dataObject.entityName = this.entityNameGet() || null;
                    dataObject.entityPropertyName = this.entityPropertyNameGet() || null;
                    dataObject.permission = this.permissionGet() || null;

                    return dataObject;
                },

                // Event Handlers
                onPermissionsChanged: function (evt)
                {
                    evt.data.self.evaluate();
                }
            };
        }
    });

    // Team Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "TeamEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        properties: [
            { name: "teamName", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                $$(document).on("seriouslyrad.PermissionCache:PermissionsChanged", { self: this }, this.onPermissionsChanged);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        value = false;

                    if (window.application?.permissionCache)
                        value = window.application.permissionCache.isInTeam(this.teamNameGet());

                    this.valueSet(value);

                    return value;
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize();

                    dataObject.teamName = this.teamNameGet() || null;

                    return dataObject;
                },

                // Event Handlers
                onPermissionsChanged: function (evt)
                {
                    evt.data.self.evaluate();
                }
            };
        }
    });

    // Has Visible Children Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "HasVisibleChildrenEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _contextChanged: function (change)
                {
                    if (change.originalValue)
                        change.originalValue.off("isVisibleChanged", { self: this }, this.onChildVisibilityChanged);

                    if (change.currentValue)
                        change.currentValue.on("isVisibleChanged", { self: this }, this.onChildVisibilityChanged);

                    this.onChildVisibilityChanged({ data: { self: this } });
                },

                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        context = this.contextGet(),
                        value = context.controlsGet().any(item => item.isVisibleGet());

                    this.valueSet(value);

                    return value;
                },

                // Event Handlers
                onChildVisibilityChanged: function (evt)
                {
                    evt.data.self.evaluate();
                }
            };
        }
    });

    // Method Evaluator
    classFactory.create({
        namespace: "seriouslyrad.logicevaluation",
        name: "MethodEvaluator",
        inherits: "seriouslyrad.logicevaluation.Evaluator",
        properties: [
            { name: "methodPath", type: "string" }
        ],
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                evaluate: function ()
                {
                    if (this.__isConstructing())
                        return;

                    var
                        method = window.objectHelper.propertyValueByPathGet(window, this.methodPathGet()),
                        value = !!(method?.apply(this));

                    this.valueSet(value);

                    return value;
                },
                serialize: function ()
                {
                    var
                        dataObject = this.super.serialize();

                    dataObject.methodPath = this.methodPathGet() || null;

                    return dataObject;
                }
            };
        }
    });

    $$(document).on("seriouslyrad.logicevaluation.Evaluator:RegisterEvaluators", (evt, registerEvaluatorCallback) =>
    {
        registerEvaluatorCallback(seriouslyrad.logicevaluation.AndEvaluator, "And");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.NotEvaluator, "Not");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.OrEvaluator, "Or");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.TrueEvaluator, "True");

        registerEvaluatorCallback(seriouslyrad.logicevaluation.HasVisibleChildrenEvaluator, "HasVisibleChildren");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.PropertyEvaluator, "Property");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.PermissionEvaluator, "Permission");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.PropertyPermissionEvaluator, "PropertyPermission");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.TeamEvaluator, "Team");
        registerEvaluatorCallback(seriouslyrad.logicevaluation.MethodEvaluator, "Method");
    });

    // #endregion

    // #region Expressions

    // Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "Expression"
    });

    // Comparison Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "ComparisonExpression",
        inherits: "Expression",
        properties: [
            { name: "path", type: "string" },
            { name: "operator", type: "string" },
            { name: "value" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                operator: namespace.ComparisonExpression.operators.equals
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.operators = {
                contains: "contains",
                equals: "equals",
                greaterThan: "greaterThan",
                greaterThanOrEqualTo: "greaterThanOrEqualTo",
                lessThan: "lessThan",
                lessThanOrEqualTo: "lessThanOrEqualTo"
            };
        }
    });

    // List Of Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "ListOfExpression",
        inherits: "Expression",
        abstract: true,
        properties: [
            { name: "expressions", type: "array" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                expressions: []
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                add: function (expression)
                {
                    this.expressionsGet().add(expression);
                },
                count: function ()
                {
                    return this.expressionsGet().length;
                },
                remove: function (expression)
                {
                    this.expressionsGet().remove(expression);
                }
            };
        }
    });

    // And Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "AndExpression",
        inherits: "ListOfExpression"
    });

    // Or Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "OrExpression",
        inherits: "ListOfExpression"
    });

    // Not Expression
    classFactory.create({
        namespace: "seriouslyrad",
        name: "NotExpression",
        inherits: "Expression",
        properties: [
            { name: "expression" }
        ]
    });

    // #endregion

    // #region Permission Cache

    // Permission Cache
    classFactory.create({
        namespace: "seriouslyrad",
        name: "PermissionCache",
        properties: [
            { name: "data", type: "object" },
            { name: "engines", type: "object" },
            { name: "permissions", type: "array" },
            { name: "propertyPermissions", type: "array" },
            { name: "teams", type: "array" },
            { name: "webApiClient" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                permissions: []
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                if (!this.webApiClientGet())
                    console.error("A webApiClient is required.");

                this._loadPermissionsAsyncPromise = null;
                this._loadingPermissionsTimeoutId = 0;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _clearUserMenu: function ()
                {
                    const
                        userMenu = $$(".rad-action-user-menu-open").radControl();

                    if (userMenu)
                    {
                        userMenu
                            .$$elementGet()
                            .find(".rad-text")
                            .empty();
                    }
                },
                _loadPermissionsAsync: function ()
                {
                    let
                        self = this;

                    if (self._loadPermissionsAsyncPromise)
                        return self._loadPermissionsAsyncPromise;

                    self._loadPermissionsAsyncPromise = Promise.public();

                    if (self._loadingPermissionsTimeoutId !== 0)
                    {
                        clearTimeout(self._loadingPermissionsTimeoutId);
                        self._loadingPermissionsTimeoutId = 0;
                    }

                    self.webApiClientGet()
                        .createApiMethodRequest("Security", "GetSecurityInformation", null, null, false)
                        .executeAsync()
                        .then(data =>
                        {
                            if (!data)
                                return;

                            self.dataSet(data);

                            self._clearUserMenu();

                            const
                                userMenu = $$(".rad-action-user-menu-open").radControl();

                            if (userMenu && data.name)
                            {
                                const
                                    $$text = userMenu.$$elementGet().find(".rad-text"),
                                    nameDetails = [{
                                        attributes: {
                                            "class": "name"
                                        },
                                        nodeName: "span",
                                        text: data.name
                                    }];

                                if (data.tenantName)
                                {
                                    nameDetails.push({
                                        attributes: {
                                            "class": "tenant"
                                        },
                                        nodeName: "span",
                                        text: data.tenantName
                                    });
                                }

                                const
                                    $$userInformation = $$.create$$(nameDetails);

                                $$text.append($$userInformation);
                            }

                            self.enginesSet(data.engines);
                            self.permissionsSet(data.permissions);
                            self.propertyPermissionsSet(data.propertyPermissions);
                            self.teamsSet(data.teams);

                            $$(document).trigger("seriouslyrad.PermissionCache:PermissionsChanged", self);

                            self._loadPermissionsAsyncPromise.resolve(data);
                        })
                        .catch(error =>
                        {
                            self._loadPermissionsAsyncPromise.reject(error);
                        })
                        .finally(() =>
                        {
                            self._loadingPermissionsTimeoutId =
                                setTimeout(() => { self.refresh(); self = null; }, namespace.PermissionCache.REFRESH_INTERVAL_IN_MINUTES * 60 * 1000);
                            self._loadPermissionsAsyncPromise = null;
                        });

                    return self._loadPermissionsAsyncPromise;
                },

                // Public Methods
                clear: function ()
                {
                    this._clearUserMenu();

                    this.dataSet(null);
                    this.permissionsSet(null);
                    this.propertyPermissionsSet(null);
                    this.teamsSet(null);

                    $$(document).trigger("seriouslyrad.PermissionCache:PermissionsChanged", self);
                },
                hasPermissionForEntity: function (entityName, permissionLevel)
                {
                    var
                        permissions = this.permissionsGet();

                    if (!permissions)
                        return false;

                    return permissions
                        .any(item => item.entityName === entityName && (item.permission & permissionLevel) > 0);
                },
                hasPermissionForEntityProperty: function (entityName, entityPropertyName, permissionLevel)
                {
                    var
                        propertyPermissions = this.propertyPermissionsGet();

                    if (!propertyPermissions)
                        return false;

                    var
                        propertyPermission =
                            propertyPermissions
                                .firstOrDefault(item => item.entityName.toLowerCase() === entityName.toLowerCase() && item.entityPropertyName.toLowerCase() === entityPropertyName.toLowerCase());

                    if (!propertyPermission)
                        return true; // Default true

                    return (propertyPermission.permission & permissionLevel) > 0;
                },
                isInTeam: function (teamName)
                {
                    var
                        teams = this.teamsGet();

                    if (!teams)
                        return false;

                    return teams.any(item => item.teamName === teamName);
                },
                refresh: function ()
                {
                    return this._loadPermissionsAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.REFRESH_INTERVAL_IN_MINUTES = 30;
        }
    });

    // #endregion

    // #region Entity Commands

    // Entity Command
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommand",
        properties: [
            { name: "description", type: "string" },
            { name: "entityName", type: "string" },
            { name: "isDefault", type: "boolean" },
            { name: "isToggle", type: "boolean" },
            { name: "key", type: "string" },
            { name: "owner" },
            { name: "permission", type: "int" },
            { name: "supportsMultipleRecords", type: "boolean" },
            { name: "type", type: "string" },
            { name: "visibleEvaluator", type: "string" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                isDefault: false,
                isToggle: false,
                supportsMultipleRecords: false
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return Promise.resolve();
                },

                // Public Methods
                clone: function ()
                {
                    var
                        visibleEvaluator = this.visibleEvaluatorGet();

                    return (
                        new this[".classDefinition"].classConstructor({
                            description: this.descriptionGet(),
                            entityName: this.entityNameGet(),
                            isDefault: this.isDefaultGet(),
                            isToggle: this.isToggleGet(),
                            key: this.keyGet(),
                            permission: this.permissionGet(),
                            type: this.typeGet(),
                            visibleEvaluator: visibleEvaluator ? visibleEvaluator.clone() : null
                        })
                    );
                },
                executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                entityCommandInformation.triggerHandler("executed");
                            })
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.types = {
                entity: "entity",
                entitySet: "entitySet"
            };
        }
    });

    // Entity Command (Delete)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandDelete",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "Delete",
                key: "DELETE",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.delete,
                type: namespace.EntityCommand.types.entity,
                visibleEvaluator: new namespace.logicevaluation.MethodEvaluator({
                    methodPath: "seriouslyrad.EntityCommandDelete.deleteVisibilityEvaluatorMethod"
                })
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    var
                        self = this;

                    return (
                        self.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                if (self.messageDialog === undefined)
                                    self.messageDialog = new seriouslyrad.ui.web.MessageDialog();

                                var
                                    entitySetName = entityCommandInformation.entitySetNameGet(),
                                    entityNameFriendly = entityCommandInformation.entityNameFriendlyGet(),
                                    record = entityCommandInformation.recordGet();

                                if (!record || !record.id)
                                    return;

                                self.messageDialog.buttonStyleSet(seriouslyrad.ui.web.Dialog.buttonStyle.yesNo);
                                self.messageDialog.titleSet(String.format("Delete {0}?", entityNameFriendly));
                                self.messageDialog.textSet(String.format("Are you sure you want to delete this {0}?", entityNameFriendly.toLowerCase()));

                                return (
                                    self.messageDialog
                                        .openAsync()
                                        .then(result =>
                                        {
                                            if (result[0] === seriouslyrad.ui.web.Dialog.dialogResult.yes)
                                            {
                                                return (
                                                    window.application.webApiClient
                                                        .createEntityDeleteRequest(
                                                            entitySetName,
                                                            record.id
                                                        )
                                                        .executeAsync()
                                                );
                                            }

                                            return Promise.reject("User cancelled");
                                        })
                                );
                            })
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.deleteVisibilityEvaluatorMethod = function ()
            {
                var
                    entityCommandInformation = this.stateGet();

                if (!entityCommandInformation)
                    return false;

                var
                    caller = entityCommandInformation.callerGet();

                if (!caller)
                    return false;

                var
                    record = entityCommandInformation.recordGet();

                if (!record)
                    return false;

                var
                    entityName = entityCommandInformation.entityNameGet();

                if (entityName === "LookupItem")
                {
                    if (record?.isLinkedToEnum)
                        return false;
                }

                return record.deletedGuid ? false : true;
            };
        }
    });

    // Entity Command (New)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandNew",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "New",
                key: "NEW",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.create,
                type: namespace.EntityCommand.types.entitySet
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                if (entityCommandInformation.openRecordInDialogGet())
                                    return window.pageManager.openPageAsDialogAsync(entityCommandInformation.createEntityUrl());

                                return window.pageManager.navigateAsync(entityCommandInformation.createEntityUrl());
                            })
                    );
                }
            };
        }
    });

    // Entity Command (Open)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandOpen",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "Open",
                isDefault: true,
                key: "OPEN",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.read,
                type: namespace.EntityCommand.types.entity
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                const
                                    record = entityCommandInformation.recordGet();

                                return (
                                    entityCommandInformation.openRecordInDialogGet()
                                        ? window.pageManager.openPageAsDialogAsync(entityCommandInformation.createEntityUrl(), { isSoftDeleted: !!(record?.deletedGuid) })
                                        : window.pageManager.navigateAsync(entityCommandInformation.createEntityUrl(), null, null, { isSoftDeleted: !!(record?.deletedGuid) })
                                );
                            })
                    );
                }
            };
        }
    });

    // Entity Command (Show Soft Deleted)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandShowSoftDeleted",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "Show Soft Deleted",
                isToggle: true,
                key: "SHOW_SOFT_DELETED",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.read,
                type: namespace.EntityCommand.types.entitySet,
                visibleEvaluator: new namespace.logicevaluation.MethodEvaluator({
                    methodPath: "seriouslyrad.EntityCommandShowSoftDeleted.showSoftDeletedVisibilityEvaluatorMethod"
                })
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                const
                                    caller = entityCommandInformation.callerGet();

                                if (!caller || !caller.includeSoftDeletedSet)
                                    return;

                                caller.includeSoftDeletedSet(value);
                            })
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.showSoftDeletedVisibilityEvaluatorMethod = function ()
            {
                var
                    entityCommandInformation = this.stateGet();

                if (!entityCommandInformation)
                    return false;

                var
                    caller = entityCommandInformation.callerGet();

                if (!caller || !caller.applicationEntitySupportsSoftDeleteGet)
                    return false;

                return !!caller.applicationEntitySupportsSoftDeleteGet();
            };
        }
    });

    // Entity Command (User - Send Password Reset Email)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandUserSendPasswordResetEmail",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "Send Password Reset Email",
                entityName: "User",
                key: "SEND_PASSWORD_RESET_EMAIL",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.execute,
                type: namespace.EntityCommand.types.entity
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                var
                                    record = entityCommandInformation.recordGet(),
                                    error;

                                if (!record)
                                    return;

                                if (!record.username || !record.username.isEmailAddress())
                                {
                                    error = "The users username is not a valid email address";

                                    if (seriouslyrad.ui.web.ErrorDialog)
                                        seriouslyrad.ui.web.ErrorDialog.displayError(error);
                                    else
                                        console.warn(error);

                                    return;
                                }

                                return (
                                    $$
                                        .ajax({
                                            type: "POST",
                                            data: { username: record.username }.toJson(),
                                            dataType: "json",
                                            contentType: "application/json",
                                            url: window.applicationInformation.serverVirtualDirectory + "api/Security/RequestResetPassword"
                                        })
                                        .then(() =>
                                        {
                                            var
                                                message = "A password reset email has been sent.";

                                            if (seriouslyrad.ui.web.MessageDialog)
                                                seriouslyrad.ui.web.MessageDialog.displayMessage("Request Password Reset", message);
                                            else
                                                console.warn(message);
                                        })
                                        .catch(xhr =>
                                        {
                                            var
                                                error = window.serverErrorHelper.processError(xhr);

                                            if (seriouslyrad.ui.web.ErrorDialog)
                                                seriouslyrad.ui.web.ErrorDialog.displayError(error);
                                            else
                                                console.error(error);

                                            throw error;
                                        })
                                );
                            })
                    );
                }
            };
        }
    });

    // Entity Command (View Audit Information)
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandViewAuditInformation",
        inherits: "EntityCommand",
        createPropertyDefaults: namespace =>
        {
            return {
                description: "View Audit Information",
                key: "VIEW_AUDIT_INFORMATION",
                permission: namespace.logicevaluation.PermissionEvaluator.permissionLevels.read,
                type: namespace.EntityCommand.types.entity
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _executeAsync: function (entityCommandInformation, value)
                {
                    return (
                        this.super._executeAsync(entityCommandInformation, value)
                            .then(() =>
                            {
                                var
                                    record = entityCommandInformation.recordGet();

                                if (!record || !record.id)
                                    return;

                                return (
                                    namespace.ui.web.EntityAuditDialog.getSingleInstance()
                                        .openAsync(entityCommandInformation.entitySetNameGet(), record.id, entityCommandInformation.entitySupportsSoftDeleteGet())
                                );
                            })
                    );
                }
            };
        }
    });

    // Entity Command Information
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityCommandInformation",
        properties: [
            { name: "caller" },
            { name: "entityName", type: "string" },
            { name: "entityNameFriendly", type: "string" },
            { name: "entitySetName", type: "string" },
            { name: "entitySetNameFriendly", type: "string" },
            { name: "entitySupportsSoftDelete", type: "boolean" },
            { name: "foreignEntityAlias", type: "string" },
            { name: "openRecordInDialog", type: "string" },
            { name: "parentEntityId", type: "string" },
            { name: "parentEntityName", type: "string" },
            { name: "parentEntitySetName", type: "string" },
            { name: "parentEntityUrl", type: "string" },
            { name: "record" },
            { name: "records", type: "array" }
        ],
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                createEntityUrl: function ()
                {
                    var
                        entitySetName = this.entitySetNameGet(),
                        foreignEntityAlias = this.foreignEntityAliasGet(),
                        parentEntityId = this.parentEntityIdGet(),
                        parentEntitySetName = this.parentEntitySetNameGet(),
                        parentEntityUrl = this.parentEntityUrlGet(),
                        record = this.recordGet(),
                        recordId = record?.id || "new";

                    if (!foreignEntityAlias)
                        return String.format("{0}{1}/{2}/", window.applicationInformation.virtualDirectory, entitySetName.toLowerCase(), recordId);
                    else
                    {
                        var
                            location = window.pathHelper.getLocation(parentEntityUrl);

                        return (
                            location.applicationRelativeUrl.trimEnd("/").split("/").length > 2
                                ? String.format("{0}{1}/{2}/{3}/{4}/", window.applicationInformation.virtualDirectory, parentEntitySetName.toLowerCase(), parentEntityId, foreignEntityAlias.toLowerCase(), recordId)
                                : String.format("{0}{1}/{2}/", location.pathname, foreignEntityAlias.toLowerCase(), recordId)
                        );
                    }
                },
                getRecordId: function ()
                {
                    var
                        record = this.recordGet();

                    return record ? record.id : null;
                }
            };
        }
    });

    // Entity Manager
    classFactory.create({
        namespace: "seriouslyrad",
        name: "EntityManager",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.entityCommands = [];
                this.removedEntityCommands = [];
                this.menu = null;
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                cloneEntityCommands: function (entityCommands)
                {
                    var
                        self = this;

                    return entityCommands.select(item => item.clone());
                },
                createEntityUrl: function (entityCommandInformation) // TODO: Remove in subsequent version
                {
                    return entityCommandInformation ? entityCommandInformation.createEntityUrl() : null;
                },
                createCommandMenu: function (entityName, commands)
                {
                    if (!commands.length)
                        return null;

                    var
                        menu = new seriouslyrad.ui.web.Menu({ text: "Actions" });

                    commands
                        .orderBy(item => String.format("{0}_{1}", item.isDefaultGet() ? "A" : "B", item.descriptionGet()))
                        .each(item =>
                        {
                            var
                                menuItem = new seriouslyrad.ui.web.MenuItem({
                                    text: item.descriptionGet(),
                                    toggle: !!item.isToggleGet(),
                                    tag: {
                                        entityCommand: item
                                    }
                                });

                            var
                                visibleEvaluator = item.visibleEvaluatorGet(),
                                permission = item.permissionGet(),
                                combinedVisibleEvaluator = new namespace.logicevaluation.AndEvaluator();

                            if (visibleEvaluator)
                                combinedVisibleEvaluator.addEvaluator(namespace.logicevaluation.Evaluator.fromDataObject(visibleEvaluator.serialize()));

                            if (permission)
                                combinedVisibleEvaluator.addEvaluator(namespace.logicevaluation.Evaluator.fromDataObject({ type: "Permission", entityName: entityName, permission: permission }));

                            if (combinedVisibleEvaluator.evaluatorsGet().length)
                                menuItem.visibleEvaluatorSet(combinedVisibleEvaluator);

                            menu.append(menuItem);
                        });

                    return menu;
                },
                executeCommand: function (entityCommandInformation)
                {
                    var
                        entityCommand = this.getEntityCommand(commandInformation.typeGet(), commandInformation.entityNameGet(), commandInformation.keyGet());

                    if (!entityCommand)
                        return;

                    entityCommand.executeAsync(entityCommandInformation);
                },
                getEntityCommand: function (type, entityName, key)
                {
                    var
                        entityCommand =
                            this.entityCommands
                                .where(item =>
                                {
                                    var
                                        itemEntityName = item.entityNameGet();

                                    return item.typeGet() === type && (itemEntityName === undefined || itemEntityName === entityName) && (key === undefined && item.isDefaultGet() || item.keyGet() === key);
                                })
                                .orderBy(item =>
                                {
                                    return String.format("{0}{1}", item.isDefaultGet() ? "0" : "1", item.entityNameGet() !== undefined ? "0" : "1");
                                })
                                .firstOrDefault();

                    return entityCommand ? entityCommand.clone() : null;
                },
                getEntityCommands: function (type, entityName, owner)
                {
                    var
                        self = this,
                        commands = [];

                    // Add entity-specific commands
                    commands.push.apply(
                        commands,
                        self.entityCommands
                            .where(item =>
                            {
                                return (
                                    item.typeGet() === type
                                    && item.entityNameGet() === entityName
                                );
                            })
                    );

                    // Add global commands
                    commands.push.apply(
                        commands,
                        self.entityCommands
                            .where(item =>
                            {
                                var
                                    itemKey = item.keyGet();

                                return (
                                    item.typeGet() === type
                                    && !item.entityNameGet()
                                    && !commands.any(itemInner => itemInner.keyGet() === itemKey)
                                );
                            })
                    );

                    // Exclude removed commands
                    commands.remove(item =>
                    {
                        return (
                            self.removedEntityCommands.any(itemInner =>
                            {
                                return (
                                    (!itemInner.entityName || itemInner.entityName === entityName)
                                    && itemInner.key === item.keyGet()
                                    && itemInner.type === item.typeGet()
                                );
                            })
                        );
                    });

                    return (
                        self.cloneEntityCommands(commands.orderBy(item => item.descriptionGet()))
                            .select(item =>
                            {
                                if (owner)
                                    item.ownerSet(owner);

                                return item;
                            })
                    );
                },
                registerCommand: function (command)
                {
                    if (command.isDefaultGet())
                    {
                        var
                            commandEntityName = command.entityNameGet(),
                            commandType = command.typeGet();

                        this.entityCommands
                            .where(item =>
                            {
                                return (
                                    item.typeGet() === commandType
                                    && item.entityNameGet() === commandEntityName
                                    && item.isDefaultGet()
                                );
                            })
                            .each(item => { item.isDefaultSet(false); });
                    }

                    this.entityCommands.push(command);
                },
                removeCommand: function (command)
                {
                    this.removedEntityCommands.push(command);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.entityManager = new classConstructor();

            $$(() =>
            {
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandDelete());
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandNew());
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandOpen());
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandShowSoftDeleted());
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandUserSendPasswordResetEmail());
                window.entityManager.registerCommand(new seriouslyrad.EntityCommandViewAuditInformation());

                $$(document).trigger("seriouslyrad.EntityManager:registerEntityCommands");
            });
        }
    });

    // #endregion

    // #region Utility

    // Utility
    classFactory.create({
        namespace: "seriouslyrad",
        name: "Utility",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.guids = [];
                this.loadingMoreGuids = false;
                this.newGuidRequests = [];
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _loadMoreGuidsAsync: function ()
                {
                    var
                        self = this;

                    self.loadingMoreGuids = true;

                    return (window.application.webApiClient
                        .createApiMethodRequest("DataService", "CallDataService", { id: "3518088d-7425-4aca-b547-94759983b375", operation: "GuidList" })
                        .executeAsync()
                        .then(data =>
                        {
                            self.loadingMoreGuids = false;
                            data.each(item => { self.guids.push(item); });
                        })
                    );
                },
                _newGuidAsync: function (waitingPromise)
                {
                    var
                        self = this,
                        promise =
                            waitingPromise
                                ? waitingPromise
                                : Promise.public();

                    if (self.loadingMoreGuids)
                        self.newGuidRequests.push(promise);
                    else
                    {
                        if (self.guids.length < 50)
                        {
                            self.newGuidRequests.push(promise);
                            self._loadMoreGuidsAsync()
                                .then(() =>
                                {
                                    var
                                        requests = self.newGuidRequests.slice(0);

                                    self.newGuidRequests = [];

                                    requests.each(item => { self._newGuidAsync(item); });
                                });
                        }
                        else
                            promise.resolve(self.guids.pop());
                    }

                    return promise;
                },

                // Public Methods
                newGuidAsync: function ()
                {
                    return this._newGuidAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.utility = new classConstructor();
        }
    });

    // #endregion

    // #region Configuration

    // Configuration Manager
    classFactory.create({
        namespace: "seriouslyrad",
        name: "ConfigurationManager",
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.applicationEntityProperties = [];
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                getApplicationEntityPropertiesForEntitySetName: function (entitySetName)
                {
                    return (
                        this.applicationEntityProperties
                            .where(item => item.entitySetName === entitySetName)
                            .orderBy(item => item.name)
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.configurationManager = new classConstructor();
        }
    });

    // #endregion

    // #region Database

    // Database
    classFactory.create({
        namespace: "seriouslyrad",
        name: "Database",
        abstract: true,
        properties: [
            { name: "databaseName", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    databaseName = this.databaseNameGet();

                if (!databaseName)
                    console.error("No database name supplied");

                if (window.sqlitePlugin)
                    this.db = window.sqlitePlugin.openDatabase({ name: String.format("{0}.db", databaseName), location: "default" });
                else
                    this.tables = {};
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createTableAsync: function (tx, tableName, columns)
                {
                    if (window.sqlitePlugin)
                        return this._executeSqlAsync(tx, String.format("CREATE TABLE IF NOT EXISTS {0} ({1})", tableName, columns.select(item => String.format("[{0}]", item)).join(", ")), []);

                    if (this.tables[tableName] === undefined)
                        this.tables[tableName] = {};

                    this.tables[tableName].rows = [];
                    this.tables[tableName].columns = columns;

                    return Promise.resolve();
                },
                _createIndexAsync: function (tx, indexName, tableName, columns, filterExpression)
                {
                    var
                        whereClause = this._expressionToWhereClause(filterExpression);

                    if (window.sqlitePlugin)
                    {
                        return (
                            this
                                ._executeSqlAsync(
                                    tx,
                                    String.format(
                                        "CREATE UNIQUE INDEX IF NOT EXISTS {0} ON {1} ({2}){3}",
                                        indexName,
                                        tableName,
                                        columns.select(item => String.format("[{0}]", item)).join(", "),
                                        whereClause ? String.format(" WHERE {0}", whereClause) : String.empty
                                    ),
                                    []
                                )
                        );
                    }

                    return Promise.resolve();
                },
                _convertObjectToDataArray: function (object)
                {
                    var
                        data = [];

                    for (let property in object)
                    {
                        if (property === "id")
                            continue;

                        data.push({ name: property, value: object[property] });
                    }

                    return data;
                },
                _deleteAllRowsAsync: function (tx, tableName)
                {
                    if (window.sqlitePlugin)
                        return this._executeSqlAsync(tx, String.format("DELETE FROM {0}", tableName));

                    this.tables[tableName].rows.remove(item => true);

                    return Promise.resolve();
                },
                _deleteRowByIdAsync: function (tx, tableName, id)
                {
                    if (window.sqlitePlugin)
                        this._executeSqlAsync(tx, String.format("DELETE FROM {0} WHERE id = ?", tableName), [id]);

                    this.tables[tableName].rows.remove(item => item.id === id);

                    return Promise.resolve();
                },
                _dropTableAsync: function (tx, tableName)
                {
                    if (window.sqlitePlugin)
                        this._executeSqlAsync(tx, String.format("DROP TABLE IF EXISTS {0}", tableName), []);

                    this.tables[tableName] = undefined;

                    return Promise.resolve();
                },
                _executeSqlAsync: function (tx, sql, parameters)
                {
                    if (window.sqlitePlugin)
                    {
                        tx = tx || this.db;

                        return (
                            new Promise((resolve, reject) =>
                            {
                                tx.executeSql(
                                    sql,
                                    parameters,
                                    rs => { resolve(rs); },
                                    (tx, error) => { reject(error); }
                                )
                            })
                        );
                    }

                    return Promise.resolve();
                },
                _executeTransactionAsync: function (callback)
                {
                    var
                        self = this;

                    if (window.sqlitePlugin)
                    {
                        return (
                            new Promise((resolve, reject) =>
                            {
                                self.db.transaction(tx => { if (callback) callback(tx); },
                                    (tx, error) => { reject(error); },
                                    () => { resolve(); });
                            })
                        );
                    }

                    if (callback)
                        callback();

                    return Promise.resolve();
                },
                _expressionToWhereClause: function (expression)
                {
                    // TODO: Replace... Used in index creation but is subject to injection
                    if (!expression)
                        return null;

                    var
                        self = this,
                        whereClause = String.empty;

                    if (expression instanceof seriouslyrad.ComparisonExpression)
                    {
                        whereClause = "[" + expression.pathGet() + "]";

                        var
                            value = expression.valueGet(),
                            valueType = objectHelper.typeOf(value);

                        if (value === null)
                        {
                            if (expression.operatorGet() === seriouslyrad.ComparisonExpression.operators.equals)
                                whereClause += " IS NULL";
                            else
                                console.error("Expression operator not supported");
                        }
                        else
                        {
                            switch (expression.operatorGet())
                            {
                                case seriouslyrad.ComparisonExpression.operators.contains:
                                    console.error("Expression operator not supported");
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.equals:
                                    whereClause += " =";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.greaterThan:
                                    whereClause += " >";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.greaterThanOrEqualTo:
                                    whereClause += " >=";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.lessThan:
                                    whereClause += " <";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.lessThanOrEqualTo:
                                    whereClause += " <=";
                                    break;
                                default:
                                    console.error("Expression operator not supported");
                                    break;
                            }

                            switch (valueType)
                            {
                                case "boolean":
                                    whereClause += String.format(" {0}", value ? "true" : "false");
                                    break;
                                case "number":
                                    whereClause += String.format(" {0}", value);
                                    break;
                                case "string":
                                    whereClause += String.format(" '{0}'", value);
                                    break;
                                default:
                                    console.error(String.format("Value type '{0}' not supported", valueType));
                                    break;
                            }
                        }
                    }
                    else if (expression instanceof seriouslyrad.ListOfExpression)
                    {
                        var
                            operator;

                        if (expression instanceof seriouslyrad.AndExpression)
                            operator = "and";
                        else if (expression instanceof seriouslyrad.OrExpression)
                            operator = "or";
                        else
                            console.error("Expression not supported");

                        expression.expressionsGet().each(item =>
                        {
                            whereClause += String.format("{0}({1})", whereClause.length ? String.format(" {0} ", operator) : String.empty, self._expressionToWhereClause(item));
                        });
                    }

                    return whereClause;
                },
                _expressionToWhereClauseInformation: function (expression, parameters)
                {
                    if (!expression)
                        return { whereClause: null, parameters: [] };

                    var
                        self = this,
                        whereClause = String.empty;

                    parameters = parameters || [];

                    if (expression instanceof seriouslyrad.ComparisonExpression)
                    {
                        whereClause = "[" + expression.pathGet() + "]";

                        var
                            value = expression.valueGet(),
                            valueType = objectHelper.typeOf(value);

                        if (value === null)
                        {
                            if (expression.operatorGet() === seriouslyrad.ComparisonExpression.operators.equals)
                                whereClause += " IS NULL";
                            else
                                console.error("Expression operator not supported");
                        }
                        else
                        {
                            switch (expression.operatorGet())
                            {
                                case seriouslyrad.ComparisonExpression.operators.contains:
                                    console.error("Expression operator not supported");
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.equals:
                                    whereClause += " = ?";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.greaterThan:
                                    whereClause += " > ?";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.greaterThanOrEqualTo:
                                    whereClause += " >= ?";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.lessThan:
                                    whereClause += " < ?";
                                    break;
                                case seriouslyrad.ComparisonExpression.operators.lessThanOrEqualTo:
                                    whereClause += " <= ?";
                                    break;
                                default:
                                    console.error("Expression operator not supported");
                                    break;
                            }

                            switch (valueType)
                            {
                                case "boolean":
                                    parameters.push(value ? "true" : "false");
                                    break;
                                case "number":
                                case "string":
                                    parameters.push(value);
                                    break;
                                default:
                                    console.error(String.format("Value type '{0}' not supported", valueType));
                                    break;
                            }
                        }
                    }
                    else if (expression instanceof seriouslyrad.ListOfExpression)
                    {
                        var
                            operator;

                        if (expression instanceof seriouslyrad.AndExpression)
                            operator = "and";
                        else if (expression instanceof seriouslyrad.OrExpression)
                            operator = "or";
                        else
                            console.error("Expression not supported");

                        expression.expressionsGet().each(item =>
                        {
                            whereClause += String.format("{0}({1})", whereClause.length ? String.format(" {0} ", operator) : String.empty, self._expressionToWhereClauseInformation(item, parameters).whereClause);
                        });
                    }

                    return {
                        whereClause: whereClause,
                        parameters: parameters
                    };
                },
                _filterArrayByExpression: function (array, expression)
                {
                    if (!expression)
                        return array;

                    var
                        self = this;

                    return array.where(item =>
                    {
                        return self._objectMatchesExpression(item, expression);
                    });
                },
                _objectMatchesExpression: function (o, expression)
                {
                    var
                        self = this,
                        result;

                    if (expression instanceof seriouslyrad.ComparisonExpression)
                    {
                        switch (expression.operatorGet())
                        {
                            case seriouslyrad.ComparisonExpression.operators.contains:
                                console.error("Expression operator not supported");
                                break;
                            case seriouslyrad.ComparisonExpression.operators.equals:
                                result = o[expression.pathGet()] === expression.valueGet();
                                break;
                            case seriouslyrad.ComparisonExpression.operators.greaterThan:
                                result = o[expression.pathGet()] > expression.valueGet();
                                break;
                            case seriouslyrad.ComparisonExpression.operators.greaterThanOrEqualTo:
                                result = o[expression.pathGet()] >= expression.valueGet();
                                break;
                            case seriouslyrad.ComparisonExpression.operators.lessThan:
                                result = o[expression.pathGet()] < expression.valueGet();
                                break;
                            case seriouslyrad.ComparisonExpression.operators.lessThanOrEqualTo:
                                result = o[expression.pathGet()] <= expression.valueGet();
                                break;
                            default:
                                console.error("Expression operator not supported");
                                break;
                        }
                    }
                    else if (expression instanceof seriouslyrad.AndExpression)
                    {
                        result = true;

                        expression.expressionsGet().each(item =>
                        {
                            if (!self._objectMatchesExpression(o, item))
                            {
                                result = false;
                                return false;
                            }
                        });
                    }
                    else if (expression instanceof seriouslyrad.OrExpression)
                    {
                        result = false;

                        expression.expressionsGet().each(item =>
                        {
                            if (self._objectMatchesExpression(o, item))
                            {
                                result = true;
                                return false;
                            }
                        });
                    }
                    else
                        console.error("Expression not supported");

                    return result;
                },
                _insertRowAsync: function (tx, tableName, id, data)
                {
                    var
                        self = this;

                    if (window.sqlitePlugin)
                    {
                        var
                            columnNames = ["id"],
                            columnValues = [id],
                            parameterMarkers = ["?"];

                        data.each(item =>
                        {
                            columnNames.push(item.name);
                            columnValues.push(item.value);
                            parameterMarkers.push("?");
                        });

                        return self._executeSqlAsync(tx, String.format("INSERT INTO {0} ({1}) VALUES ({2})", tableName, columnNames.select(item => String.format("[{0}]", item)).join(", "), parameterMarkers.join(", ")), columnValues);
                    }

                    return (
                        self._selectRowsByIdAsync(tx, tableName, id)
                            .then(rows =>
                            {
                                if (rows.length !== 0)
                                    throw new Error("Row already exists in the database");

                                var
                                    row = {};

                                self.tables[tableName].columns
                                    .each(item => { row[item] = null; });

                                row.id = id;

                                data
                                    .each(item => { row[item.name] = item.value; });

                                self.tables[tableName].rows.push(row);

                                return row;
                            })
                    );
                },
                _resultSetToArray: function (rs)
                {
                    var
                        returnValue = [];

                    if (rs.rows.length)
                    {
                        for (var i = 0; i < rs.rows.length; i++)
                            returnValue.push(rs.rows.item(i));
                    }

                    return returnValue;
                },
                _selectRowsAsync: function (tx, tableName, filterExpression, orderByExpression) // TODO: improve orderby expression
                {
                    if (!orderByExpression)
                        orderByExpression = "";

                    var
                        self = this,
                        whereClauseInformation = self._expressionToWhereClauseInformation(filterExpression);

                    if (window.sqlitePlugin)
                    {
                        return (
                            self._executeSqlAsync(tx, String.format("SELECT * FROM {0}{1}", tableName, whereClauseInformation.whereClause ? String.format(" WHERE {0}", whereClauseInformation.whereClause) : String.empty) + orderByExpression, whereClauseInformation.parameters)
                                .then(rs =>
                                {
                                    return self._resultSetToArray(rs);
                                })
                        );
                    }

                    return Promise.resolve(self._filterArrayByExpression(self.tables[tableName].rows, filterExpression));
                },
                _selectRowsByIdAsync: function (tx, tableName, id)
                {
                    var
                        self = this;

                    if (window.sqlitePlugin)
                    {
                        return (
                            self._executeSqlAsync(tx, String.format("SELECT * FROM {0} WHERE [id] = ?", tableName), [id])
                                .then(rs =>
                                {
                                    return self._resultSetToArray(rs);
                                })
                        );
                    }

                    return Promise.resolve(self.tables[tableName].rows.where(item => item.id === id));
                },
                _updateRowByIdAsync: function (tx, tableName, id, data)
                {
                    if (window.sqlitePlugin)
                    {
                        var
                            parameterMarkers = [],
                            parameters = [];

                        data.each(item =>
                        {
                            parameterMarkers.push(String.format("[{0}] = ?", item.name));
                            parameters.push(item.value);
                        });
                        parameters.push(id);

                        return this._executeSqlAsync(tx, String.format("UPDATE {0} SET {1} WHERE id = ?", tableName, parameterMarkers.join(", ")), parameters);
                    }

                    return (
                        this._selectRowsByIdAsync(tx, tableName, id)
                            .then(row =>
                            {
                                data.each(item =>
                                {
                                    row[item.name] = item.value;
                                });

                                return row;
                            })
                    );
                }
            };
        }
    });

    // #endregion

    // #region File System

    // File Storage
    classFactory.create({
        namespace: "seriouslyrad",
        name: "FileStorage",
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                copyFileEntryAsync: function (fileEntry, directoryEntry, fileName)
                {
                    return (
                        new Promise((resolve, reject) =>
                        {
                            fileEntry.copyTo(
                                directoryEntry,
                                fileName,
                                fileEntry => { resolve(fileEntry); },
                                error => { reject(error); }
                            )
                        })
                    );
                },
                createDirectoryAsync: function (directoryEntry, name)
                {
                    if (window.cordova)
                    {
                        return (
                            new Promise((resolve, reject) =>
                            {
                                directoryEntry.getDirectory(
                                    name,
                                    { create: true },
                                    subDirectoryEntry => { resolve(subDirectoryEntry); },
                                    error => { reject(error); }
                                );
                            })
                        );
                    }

                    return Promise.resolve(new seriouslyrad.FileStorage.DirectoryEntry({ name: name, fullPath: String.format("{0}{1}/", directoryEntry.fullPath, name) }));
                },
                createDirectoryPathAsync: function (directoryEntry, path)
                {
                    var
                        self = this,
                        pathParts = path.trim("/").split("/"),
                        index = 0;

                    if (path.length === 0)
                        console.error("No path supplied");

                    return (
                        new Promise((resolve, reject) =>
                        {
                            function createNextDirectory(currentDirectory)
                            {
                                self.createDirectoryAsync(currentDirectory, pathParts[index])
                                    .then(subDirectoryEntry =>
                                    {
                                        if (index === pathParts.length - 1)
                                            resolve(subDirectoryEntry);
                                        else
                                        {
                                            index++;
                                            createNextDirectory(subDirectoryEntry);
                                        }
                                    })
                                    .catch(error =>
                                    {
                                        reject(error);
                                    });
                            }

                            createNextDirectory(directoryEntry);
                        })
                    );
                },
                getDataDirectoryAsync: function ()
                {
                    if (window.cordova)
                        return this.getEntryAsync(cordova.file.dataDirectory);

                    return Promise.resolve(new seriouslyrad.FileStorage.DirectoryEntry({ name: "data", fullPath: "/fake/data/" }));
                },
                getEntryAsync: function (url)
                {
                    if (window.cordova)
                    {
                        return new Promise((resolve, reject) =>
                        {
                            window.resolveLocalFileSystemURL(
                                url,
                                entry => { resolve(entry); },
                                error => { reject(error); }
                            );
                        });
                    }

                    var
                        isDirectory = url.endsWith("/"),
                        pathParts = url.trimEnd("/").split("/"),
                        name = pathParts[pathParts.length - 1];

                    if (isDirectory)
                        return Promise.resolve(new seriouslyrad.FileStorage.DirectoryEntry({ name: name, fullPath: url }));

                    return Promise.resolve(new seriouslyrad.FileStorage.FileEntry({ name: name, fullPath: url }));
                },
                getFileAsync: function (directoryEntry, name, options)
                {
                    options = options || { create: false };

                    if (window.cordova)
                    {
                        return new Promise((resolve, reject) =>
                        {
                            directoryEntry.getFile(
                                name,
                                options,
                                fileEntry => { resolve(fileEntry); },
                                error => { reject(error); }
                            );
                        });
                    }

                    var
                        fullPath = directoryEntry.fullPath + name;

                    if (options.create || localStorage.getItem(fullPath))
                        return Promise.resolve(new seriouslyrad.FileStorage.FileEntry({ name: name, fullPath: directoryEntry.fullPath + name }));

                    return Promise.reject("File not found");
                },
                readFileAsTextAsync: function (directoryEntry, name)
                {
                    return (
                        this.getFileAsync(directoryEntry, name)
                            .then(fileEntry =>
                            {
                                return new Promise((resolve, reject) =>
                                {
                                    fileEntry.file(
                                        file =>
                                        {
                                            var
                                                fileReader =
                                                    window.cordova
                                                        ? new FileReader()
                                                        : new seriouslyrad.FileStorage.FileReader();

                                            fileReader.onload =
                                                () => { resolve(fileReader.result); };

                                            fileReader.onerror =
                                                e => { reject(e); };

                                            fileReader.readAsText(file);
                                        },
                                        error => { reject(error); }
                                    );
                                });
                            })
                    );
                },
                saveBlobAsync: function (directoryEntry, name, blob)
                {
                    var
                        self = this;

                    return (
                        self.getFileAsync(directoryEntry, name, { create: true, exclusive: false })
                            .then(fileEntry =>
                            {
                                return new Promise((resolve, reject) =>
                                {
                                    fileEntry.createWriter(fileWriter =>
                                    {
                                        fileWriter.onwrite =
                                            () =>
                                            {
                                                blob = null;
                                                resolve(fileEntry);
                                            };

                                        fileWriter.onerror =
                                            e => { reject(e); };

                                        fileWriter.write(blob);
                                    });
                                });

                            })
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            // Directory Entry
            classFactory.create({
                namespace: classConstructor,
                name: "DirectoryEntry",
                properties: [
                    { name: "name", type: "string" },
                    { name: "fullPath", type: "string" }
                ],
                createConstructor: namespace =>
                {
                    return function ()
                    {
                        this.isFile = false;
                        this.isDirectory = true;

                        // Trigger Property Changes
                        this.nameTriggerChange();
                        this.fullPathTriggerChange();
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        // "Protected" Methods
                        _fullPathChanged: function (data)
                        {
                            this.fullPath = data.currentValue;
                        },
                        _nameChanged: function (data)
                        {
                            this.name = data.currentValue;
                        },

                        // Public Methods
                        getDirectory: function (name, options, successCallback, errorCallback)
                        {
                            if (successCallback)
                                successCallback(new seriouslyrad.FileStorage.DirectoryEntry({ name: "data", fullPath: String.format("{0}{1}/", this.fullPathGet(), name) }));
                        },
                        removeRecursively: function (successCallback, errorCallback)
                        {
                            if (successCallback)
                                successCallback();
                        }
                    };
                }
            });

            // File Entry
            classFactory.create({
                namespace: classConstructor,
                name: "FileEntry",
                inherits: classConstructor.DirectoryEntry,
                createConstructor: namespace =>
                {
                    return function ()
                    {
                        this.isFile = true;
                        this.isDirectory = false;
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        copyTo: function (directoryEntry, fileName, successCallback, errorCallback)
                        {
                            if (successCallback)
                            {
                                setTimeout(() =>
                                {
                                    successCallback(new seriouslyrad.FileStorage.FileEntry({ name: fileName, fullPath: String.format("{0}{1}", directoryEntry.fullPath, filename) }));
                                });
                            }
                        },
                        createWriter: function (callback)
                        {
                            var
                                self = this;

                            if (callback)
                            {
                                setTimeout(() =>
                                {
                                    callback(new seriouslyrad.FileStorage.FileWriter(self));
                                });
                            }
                        },
                        file: function (succeededCallback, failedCallback)
                        {
                            var
                                self = this;

                            if (succeededCallback)
                            {
                                setTimeout(() =>
                                {
                                    succeededCallback(self);
                                });
                            }
                        },
                        remove: function ()
                        {
                            localStorage.removeItem(this.fullPath);
                        },
                        toURL: function ()
                        {
                            return this.fullPath;
                        }
                    };
                }
            });

            // File Reader
            classFactory.create({
                namespace: classConstructor,
                name: "FileReader",
                createPrototype: namespace =>
                {
                    return {
                        readAsText: function (file)
                        {
                            this.result = localStorage.getItem(file.fullPath);
                            this.onload();
                        }
                    };
                }
            });

            // File Writer
            classFactory.create({
                namespace: classConstructor,
                name: "FileWriter",
                createConstructor: namespace =>
                {
                    return function (fileEntry)
                    {
                        this.fileEntry = fileEntry;
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        write: function (data)
                        {
                            localStorage.setItem(this.fileEntry.fullPath, data);
                            this.onwrite();
                        }
                    };
                }
            });
        }
    });

    // #endregion

    // #region Health

    // Health
    classFactory.create({
        namespace: "seriouslyrad",
        name: "Health",
        properties: [
            { name: "dataTypes" },
            { name: "initialized", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                initialized: false
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _isAvailableAsync: function ()
                {
                    var
                        self = this;

                    if (!navigator.health || !navigator.health.isAvailable)
                        return Promise.reject();

                    return new Promise((resolve, reject) =>
                    {
                        navigator.health.isAvailable(
                            (...args) => { resolve.apply(self, args); },
                            (...args) => { reject.apply(self, args); }
                        );
                    });
                },
                _onContinueAfterInstallFitAsync: function ()
                {
                    return Promise.resolve();
                },
                _onNotifyInstallFitAsync: function ()
                {
                    return Promise.resolve();
                },
                _onNotifyInstallHealthAsync: function ()
                {
                    return Promise.resolve();
                },
                _onRequestAuthorizationFailedAsync: function ()
                {
                    return Promise.resolve();
                },
                _promptInstallApiAsync: function ()
                {
                    var
                        self = this,
                        platform = window.application._getPlatform();

                    switch (platform)
                    {
                        case "android":
                            if (!navigator.health || !navigator.health.promptInstallFit)
                                return Promise.reject("navigator.health.promptInstallFit not available");

                            return (
                                self._onNotifyInstallFitAsync()
                                    .then((...args) =>
                                    {
                                        return new Promise((resolve, reject) =>
                                        {
                                            if (!args.length)
                                            {
                                                reject.apply(self, args);
                                                return;
                                            }

                                            navigator.health.promptInstallFit(
                                                () =>
                                                {
                                                    self._onContinueAfterInstallFitAsync()
                                                        .then((...args) =>
                                                        {
                                                            resolve.apply(self, args);
                                                        })
                                                        .catch((...args) =>
                                                        {
                                                            reject.apply(self, args);
                                                        });
                                                },
                                                (...args) =>
                                                {
                                                    reject.apply(self, args);
                                                }
                                            );
                                        });

                                    })
                            );
                        case "ios":
                            return new Promise((_, reject) =>
                            {
                                self._onNotifyInstallHealthAsync()
                                    .then((...args) => { reject.apply(promise, args); });
                            });
                        default:
                            return Promise.reject();
                    }
                },
                _requestAuthorizationAsync: function ()
                {
                    var
                        self = this;

                    if (!navigator.health || !navigator.health.requestAuthorization)
                        return Promise.reject("navigator.health.requestAuthorization not available");

                    return new Promise((resolve, reject) =>
                    {
                        navigator.health.requestAuthorization(
                            self.dataTypesGet(),
                            (...args) => { resolve.apply(self, args); },
                            (...args) => { reject.apply(self, args); }
                        );
                    });
                },
                _testAsync: function ()
                {
                    var
                        self = this,
                        endDate = new Date(),
                        startDate = endDate.addDays(-7);

                    return new Promise((resolve, reject) =>
                    {
                        self
                            .queryAggregatedAsync({
                                startDate: startDate,
                                endDate: endDate,
                                dataType: "steps",
                                bucket: "day",
                                filtered: true
                            })
                            .then(data =>
                            {
                                var
                                    steps = 0;

                                if (data?.length)
                                {
                                    for (var i = 0; i < data.length; i++)
                                        steps += parseInt(data[i].value);
                                }

                                if (steps === 0)
                                {
                                    resolve(false);
                                    return;
                                }

                                resolve(true);
                            })
                            .catch(() =>
                            {
                                resolve(false);
                            });
                    });
                },

                // Public Methods
                initializeAsync: function ()
                {
                    var
                        self = this,
                        isAvailable = null;

                    return new Promise((resolve, reject) =>
                    {
                        function initialize(self, resolve, reject)
                        {
                            self._isAvailableAsync()
                                .then(result =>
                                {
                                    isAvailable = result;

                                    if (!isAvailable)
                                        return self._promptInstallApiAsync();
                                })
                                .then(() =>
                                {
                                    if (!isAvailable)
                                    {
                                        initialize(self, resolve, reject);
                                        return;
                                    }

                                    self._requestAuthorizationAsync()
                                        .then(() =>
                                        {
                                            return self._testAsync();
                                        })
                                        .then(result =>
                                        {
                                            if (!result)
                                            {
                                                reject("NoData");
                                                return;
                                            }

                                            resolve();
                                        })
                                        .catch(() =>
                                        {
                                            self._onRequestAuthorizationFailedAsync()
                                                .finally(() =>
                                                {
                                                    reject("HealthAccessDenied");
                                                });
                                        });
                                })
                                .catch(error =>
                                {
                                    switch (window.application._getPlatform())
                                    {
                                        case "android":
                                            reject("MissingGoogleFit");
                                            break;
                                        case "ios":
                                            reject("MissingAppleHealth");
                                            break;
                                        default:
                                            reject("DeviceNotSupported");
                                            break;
                                    }
                                });
                        }

                        initialize(self, resolve, reject);
                    });
                },
                queryAsync: function (parameters)
                {
                    var
                        self = this;

                    if (!navigator.health || !navigator.health.query)
                        return Promise.reject("navigator.health.query not available");

                    return new Promise((resolve, reject) =>
                    {
                        navigator.health.query(
                            parameters,
                            (...args) => { resolve.apply(self, args); },
                            (...args) => { reject.apply(self, args); }
                        );
                    });
                },
                queryAggregatedAsync: function (parameters)
                {
                    var
                        self = this;

                    if (!navigator.health || !navigator.health.queryAggregated)
                        return Promise.reject("navigator.health.queryAggregated not available");

                    return new Promise((resolve, reject) =>
                    {
                        navigator.health.queryAggregated(
                            parameters,
                            (...args) => { resolve.apply(self, args); },
                            (...args) => { reject.apply(self, args); }
                        );
                    });
                }
            };
        }
    });

    // #endregion

    // #region Weak Map

    classFactory.create({
        name: "WeakMap",
        namespace: "seriouslyrad",
        createConstructor: namespace =>
        {
            return function ()
            {
                this._initialize();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _dispose: function ()
                {
                    for (let property in this.map)
                        delete this.map[property];

                    this.super._dispose();
                },
                _initialize: function ()
                {
                    this.keyIdFactory =
                    {
                        id: 0,
                        getNextId: function ()
                        {
                            return `key-${this.id++}`;
                        }
                    };

                    this.id = namespace.WeakMap.weakMapIdFactory.getNextId();
                    this.map = {};
                },

                // Public Methods
                delete: function (key)
                {
                    const
                        weakMapKey = key[this.id];

                    delete key[this.id];

                    if (weakMapKey)
                        delete this.map[weakMapKey];
                },
                get: function (key)
                {
                    const
                        weakMapKey = key[this.id];

                    return weakMapKey && this.map[weakMapKey];
                },
                has: function (key)
                {
                    return !!this.get(key);
                },
                set: function (key, value)
                {
                    let
                        weakMapKey = key[this.id];

                    if (!weakMapKey)
                    {
                        weakMapKey = this.keyIdFactory.getNextId();
                        key[this.id] = weakMapKey;
                    }

                    this.map[weakMapKey] = value;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.weakMapIdFactory =
            {
                id: 0,
                getNextId: function ()
                {
                    return `.weakMap-${this.id++}`;
                }
            };

            if (!window.WeakMap)
                window.WeakMap = classConstructor;
        }
    });

    // #endregion

    // #region Web Worker

    classFactory.create({
        namespace: "seriouslyrad",
        name: "WebWorkerPool",
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self.messageId = 0;
                self.promises = {};
                self.workerScriptMapping = [];
                self.workerPools = [];
                self.activeWorkers = [];
                self.maxWorkers = navigator.hardwareConcurrency || 4;
                self.requestQueue = [];

                self.onMessage = evt =>
                {
                    var
                        promise = self.promises[evt.data.id];

                    if (evt.data.success)
                        promise.resolve(evt.data.result);
                    else
                        promise.reject(evt.data.error);

                    delete self.promises[evt.data.id];
                    self.activeWorkers.remove(evt.target);

                    var
                        workerScriptMapping = self.workerScriptMapping.first(item => item.worker === evt.target),
                        workerPool = self.workerPools.first(item => item.script === workerScriptMapping.script);

                    workerPool.workers.push(evt.target);

                    if (self.requestQueue.length)
                        self._postMessageAsync(self.requestQueue.shift());
                };
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createWorker: function (script)
                {
                    var
                        workerPool =
                            this.workerPools.firstOrDefault(item => item.script === script);

                    if (!workerPool)
                    {
                        workerPool = {
                            script: script,
                            workers: []
                        };
                        this.workerPools.push(workerPool);
                    }

                    if (workerPool.workers.length)
                        return workerPool.workers.shift();
                    else
                    {
                        worker = new Worker(script);
                        worker.addEventListener("message", this.onMessage);
                        this.workerScriptMapping.push({ script: script, worker: worker });
                        return worker;
                    }
                },
                _postMessageAsync: function (request)
                {
                    var
                        worker = this._createWorker(request.script),
                        messageId = this.messageId++;

                    this.activeWorkers.push(worker);

                    this.promises[messageId] = request.promise;

                    worker.postMessage({
                        id: messageId,
                        action: request.action,
                        method: request.method,
                        args: request.args
                    });

                    return this.promises[messageId];
                },

                // Public Methods
                postMessageAsync: function (script, action, method, args)
                {
                    var
                        request = {
                            promise: Promise.public(),
                            script: script,
                            action: action,
                            method: method,
                            args: args
                        };

                    if (this.activeWorkers.length >= this.maxWorkers)
                        this.requestQueue.push(request);
                    else
                        this._postMessageAsync(request);

                    return request.promise;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            if (window.Worker)
                namespace.webWorkerPool = new classConstructor();
        }
    });

    // #endregion

    // #region Data Type Provider

    classFactory.create({
        namespace: "seriouslyrad",
        name: "DataTypeProvider",
        abstract: true,
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                getDataTypeById: function (id)
                {
                    throw new Error("Not Implemented");
                }
            };
        }
    });

    // #endregion

}